{
  "translation": {
    "allocations": {
      "actions": {
        "assign": "Attribuer"
      },
      "errors": {
        "deleting": "",
        "saving": "",
        "validation": ""
      },
      "fields": {
        "employee": "Alloué à"
      },
      "successes": {
        "deleted": "",
        "save": ""
      }
    },
    "appointments": {
      "actions": {
        "block": "",
        "calculate": "",
        "cancel": "annuler",
        "intake": "Admission",
        "new": "Nouveau rendez-vous",
        "preview": "",
        "reschedule": "Replanifier",
        "sendreminder": "",
        "unblock": "",
        "viewjob": "Voir le travail"
      },
      "errors": {
        "blocking": "",
        "canceling": "Erreur lors de l'annulation du rendez-vous. {{message}}",
        "saving": "Erreur lors de la planification du rendez-vous. {{message}}"
      },
      "fields": {
        "alt_transport": "",
        "color": "",
        "end": "",
        "note": "",
        "start": "",
        "time": "",
        "title": "Titre"
      },
      "labels": {
        "arrivedon": "Arrivé le:",
        "arrivingjobs": "",
        "blocked": "",
        "bp": "",
        "cancelledappointment": "Rendez-vous annulé pour:",
        "completingjobs": "",
        "dataconsistency": "",
        "expectedjobs": "",
        "expectedprodhrs": "",
        "history": "",
        "inproduction": "",
        "manualevent": "",
        "noarrivingjobs": "",
        "nocompletingjobs": "",
        "nodateselected": "Aucune date n'a été sélectionnée.",
        "owner": "",
        "priorappointments": "Rendez-vous précédents",
        "reminder": "",
        "ro_number": "",
        "scheduled_completion": "",
        "scheduledfor": "Rendez-vous prévu pour:",
        "severalerrorsfound": "",
        "smartscheduling": "",
        "smspaymentreminder": "",
        "suggesteddates": "",
        "vehicle": ""
      },
      "successes": {
        "canceled": "Rendez-vous annulé avec succès.",
        "created": "Rendez-vous planifié avec succès.",
        "saved": ""
      }
    },
    "associations": {
      "actions": {
        "activate": "Activer"
      },
      "fields": {
        "active": "Actif?",
        "shopname": "nom de la boutique"
      },
      "labels": {
        "actions": "actes"
      }
    },
    "audio": {
      "manager": {
        "description": ""
      }
    },
    "audit": {
      "fields": {
        "cc": "",
        "contents": "",
        "created": "",
        "operation": "",
        "status": "",
        "subject": "",
        "to": "",
        "useremail": "",
        "values": ""
      }
    },
    "audit_trail": {
      "messages": {
        "admin_job_remove_from_ar": "",
        "admin_jobmarkexported": "",
        "admin_jobmarkforreexport": "",
        "admin_jobuninvoice": "",
        "admin_jobunvoid": "",
        "alerttoggle": "",
        "appointmentcancel": "",
        "appointmentinsert": "",
        "assignedlinehours": "",
        "billdeleted": "",
        "billmarkforreexport": "",
        "billposted": "",
        "billupdated": "",
        "failedpayment": "",
        "jobassignmentchange": "",
        "jobassignmentremoved": "",
        "jobchecklist": "",
        "jobclosedwithbypass": "",
        "jobconverted": "",
        "jobdelivery": "",
        "jobexported": "",
        "jobfieldchanged": "",
        "jobimported": "",
        "jobinproductionchange": "",
        "jobintake": "",
        "jobinvoiced": "",
        "jobioucreated": "",
        "joblineupdate": "",
        "jobmanualcreate": "",
        "jobmanuallineinsert": "",
        "jobmodifylbradj": "",
        "jobnoteadded": "",
        "jobnotedeleted": "",
        "jobnoteupdated": "",
        "jobspartsorder": "",
        "jobspartsreturn": "",
        "jobstatuschange": "",
        "jobsupplement": "",
        "jobsuspend": "",
        "jobvoid": "",
        "paymententered": "",
        "paymentupdated": "",
        "tasks_completed": "",
        "tasks_created": "",
        "tasks_deleted": "",
        "tasks_uncompleted": "",
        "tasks_undeleted": "",
        "tasks_updated": "",
        "techjobstatuschange": "",
        "timeticketcreated": "",
        "timeticketpayall": "",
        "timeticketupdated": ""
      }
    },
    "billlines": {
      "actions": {
        "newline": ""
      },
      "fields": {
        "actual_cost": "",
        "actual_price": "",
        "confidence": "",
        "cost_center": "",
        "federal_tax_applicable": "",
        "jobline": "",
        "line_desc": "",
        "local_tax_applicable": "",
        "location": "",
        "oem_partno": "",
        "quantity": "",
        "state_tax_applicable": ""
      },
      "labels": {
        "deductedfromlbr": "",
        "entered": "",
        "from": "",
        "mod_lbr_adjustment": "",
        "other": "",
        "reconciled": "",
        "unreconciled": ""
      },
      "validation": {
        "atleastone": ""
      }
    },
    "bills": {
      "actions": {
        "deductallhours": "",
        "edit": "",
        "receive": "",
        "return": ""
      },
      "errors": {
        "calculating_totals": "",
        "calculating_totals_generic": "",
        "creating": "",
        "deleting": "",
        "existinginventoryline": "",
        "exporting": "",
        "exporting-partner": "",
        "invalidro": "",
        "invalidvendor": "",
        "validation": ""
      },
      "fields": {
        "allpartslocation": "",
        "date": "",
        "exported": "",
        "federal_tax_rate": "",
        "invoice_number": "",
        "is_credit_memo": "",
        "is_credit_memo_short": "",
        "local_tax_rate": "",
        "ro_number": "",
        "state_tax_rate": "",
        "total": "",
        "vendor": "",
        "vendorname": ""
      },
      "labels": {
        "actions": "",
        "ai": {
          "accept_and_continue": "",
          "confidence": {
            "breakdown": "",
            "match": "",
            "missing_data": "",
            "ocr": "",
            "overall": ""
          },
          "disclaimer_title": "",
          "feedback_placeholder": "",
          "feedback_prompt": "",
          "generic_failure": "",
          "multipage": "",
          "processing": "",
          "scan": "",
          "scancomplete": "",
          "scanfailed": "",
          "scanstarted": "",
          "submit_feedback": ""
        },
        "bill_lines": "",
        "bill_total": "",
        "billcmtotal": "",
        "bills": "",
        "calculatedcreditsnotreceived": "",
        "creditsnotreceived": "",
        "creditsreceived": "",
        "dedfromlbr": "",
        "deleteconfirm": "",
        "discrepancy": "",
        "discrepwithcms": "",
        "discrepwithlbradj": "",
        "editadjwarning": "",
        "entered_total": "",
        "enteringcreditmemo": "",
        "federal_tax": "",
        "federal_tax_exempt": "",
        "generatepartslabel": "",
        "iouexists": "",
        "local_tax": "",
        "markexported": "",
        "markforreexport": "",
        "new": "",
        "nobilllines": "",
        "noneselected": "",
        "onlycmforinvoiced": "",
        "printlabels": "",
        "retailtotal": "",
        "returnfrombill": "",
        "savewithdiscrepancy": "",
        "state_tax": "",
        "subtotal": "",
        "totalreturns": ""
      },
      "successes": {
        "created": "",
        "deleted": "",
        "exported": "",
        "markexported": "",
        "reexport": ""
      },
      "validation": {
        "closingperiod": "",
        "inventoryquantity": "",
        "manualinhouse": "",
        "unique_invoice_number": ""
      }
    },
    "bodyshop": {
      "actions": {
        "add_adjuster": "",
        "add_control_number": "",
        "add_cost_center": "",
        "add_courtesy_car_rate_preset": "",
        "add_delivery_checklist_item": "",
        "add_dms_allocation": "",
        "add_estimator": "",
        "add_insurance_company": "",
        "add_intake_checklist_item": "",
        "add_jobline_preset": "",
        "add_messaging_preset": "",
        "add_note_preset": "",
        "add_parts_order_comment": "",
        "add_production_status_color": "",
        "add_profit_center": "",
        "add_task_preset": "",
        "add_to_email_preset": "",
        "addapptcolor": "",
        "addbucket": "",
        "addpartslocation": "",
        "addpartsrule": "",
        "addspeedprint": "",
        "addtemplate": "",
        "newlaborrate": "",
        "newsalestaxcode": "",
        "newstatus": "",
        "save_shop_information": "",
        "testrender": ""
      },
      "errors": {
        "creatingdefaultview": "",
        "duplicate_insurance_company": "",
        "duplicate_job_status": "",
        "loading": "Impossible de charger les détails de la boutique. Veuillez appeler le support technique.",
        "media_tag_in_use": "L’étiquette « {{tag}} » est attribuée à un ou plusieurs fichiers et ne peut pas être supprimée.",
        "media_tag_reserved": "« {{tag}} » est réservé au stockage multimédia et ne peut pas être utilisé comme étiquette. Noms réservés : {{reservedTags}}.",
        "media_tag_usage_loading": "L’utilisation des étiquettes est en cours de vérification. Attendez la fin de la vérification avant de supprimer une étiquette existante.",
        "media_tag_usage_unavailable": "L’utilisation des étiquettes n’a pas pu être vérifiée. Les étiquettes existantes ne peuvent pas être supprimées tant que le fournisseur multimédia n’est pas disponible.",
        "saving": "",
        "task_preset_allocation_exceeded": ""
      },
      "fields": {
        "ReceivableCustomField": "",
        "accumulatePayableLines": "",
        "address1": "",
        "address2": "",
        "appt_alt_transport": "",
        "appt_colors": {
          "color": "",
          "label": ""
        },
        "appt_length": "",
        "attach_pdf_to_email": "",
        "batchid": "",
        "bill_allow_post_to_closed": "",
        "bill_federal_tax_rate": "",
        "bill_local_tax_rate": "",
        "bill_state_tax_rate": "",
        "city": "",
        "closingperiod": "",
        "companycode": "",
        "country": "",
        "dailybodytarget": "",
        "dailypainttarget": "",
        "default": "",
        "default_adjustment_rate": "",
        "deliver": {
          "require_actual_delivery_date": "",
          "templates": ""
        },
        "disableBillCostCalculation": "",
        "dms": {
          "apcontrol": "",
          "appostingaccount": "",
          "cashierid": "",
          "default_journal": "",
          "disablebillwip": "",
          "disablecontact": "",
          "disablecontactvehiclecreation": "",
          "dms_acctnumber": "",
          "dms_control_override": "",
          "dms_wip_acctnumber": "",
          "generic_customer_number": "",
          "itc_federal": "",
          "itc_local": "",
          "itc_state": "",
          "mappingname": "",
          "ro_posting": "",
          "sendmaterialscosting": "",
          "srcco": ""
        },
        "email": "",
        "enforce_class": "",
        "enforce_conversion_category": "",
        "enforce_conversion_csr": "",
        "enforce_referral": "",
        "enforce_registration_number": "Appliquer le numéro d’immatriculation lors de la conversion ?",
        "federal_tax_id": "",
        "ignoreblockeddays": "",
        "inhousevendorid": "",
        "insurance_vendor_id": "",
        "intake": {
          "next_contact_hours": "",
          "templates": ""
        },
        "intellipay_config": {
          "cash_discount_percentage": "",
          "enable_cash_discount": "",
          "payment_map": {
            "amex": "American Express",
            "disc": "Discover",
            "dnrs": "Diners",
            "intr": "Interac",
            "jcb": "JCB",
            "mast": "MasterCard",
            "visa": "Visa"
          },
          "payment_type": ""
        },
        "invoice_federal_tax_rate": "",
        "invoice_local_tax_rate": "",
        "invoice_state_tax_rate": "",
        "jc_hourly_rates": {
          "mapa": "",
          "mash": ""
        },
        "last_name_first": "",
        "lastnumberworkingdays": "",
        "localmediaserverhttp": "",
        "localmediaservernetwork": "",
        "localmediatoken": "",
        "logo_img_footer_margin": "",
        "logo_img_header_margin": "",
        "logo_img_path": "",
        "logo_img_path_height": "",
        "logo_img_path_width": "",
        "md_categories": "",
        "md_ccc_rates": "",
        "md_classes": "",
        "md_ded_notes": "",
        "md_email_cc": "",
        "md_from_emails": "",
        "md_functionality_toggles": {
          "enhanced_early_ros": "",
          "parts_queue_toggle": ""
        },
        "md_hour_split": {
          "paint": "",
          "prep": ""
        },
        "md_ins_co": {
          "city": "",
          "name": "",
          "private": "",
          "state": "",
          "street1": "",
          "street2": "",
          "zip": ""
        },
        "md_jobline_presets": "",
        "md_lost_sale_reasons": "",
        "md_parts_order_comment": "",
        "md_parts_scan": {
          "caseInsensitive": "",
          "expression": "",
          "field": "",
          "flags": "",
          "mark_critical": "",
          "operation": "",
          "update_field": "",
          "update_value": "",
          "value": ""
        },
        "md_payment_types": "",
        "md_referral_sources": "",
        "md_ro_guard": {
          "enabled": "",
          "enforce_ar": "",
          "enforce_bills": "",
          "enforce_cm": "",
          "enforce_labor": "",
          "enforce_ppd": "",
          "enforce_profit": "",
          "enforce_sublet": "",
          "masterbypass": "",
          "totalgppercent_minimum": ""
        },
        "md_tasks_presets": {
          "enable_tasks": "",
          "hourstype": "",
          "memo": "",
          "name": "",
          "nextstatus": "",
          "percent": "",
          "use_approvals": ""
        },
        "messaginglabel": "",
        "messaginglabel_short": "",
        "messagingtext": "",
        "messagingtext_short": "",
        "noteslabel": "",
        "noteslabel_short": "",
        "notestext": "",
        "notestext_short": "",
        "notifications": {
          "description": "",
          "invalid_followers": "",
          "placeholder": ""
        },
        "partslocation": "",
        "phone": "",
        "prodtargethrs": "",
        "rbac": {
          "accounting": {
            "exportlog": "",
            "payables": "",
            "payments": "",
            "receivables": ""
          },
          "bills": {
            "delete": "",
            "enter": "",
            "list": "",
            "reexport": "",
            "view": ""
          },
          "contracts": {
            "create": "",
            "detail": "",
            "list": ""
          },
          "courtesycar": {
            "create": "",
            "detail": "",
            "list": ""
          },
          "csi": {
            "export": "",
            "page": ""
          },
          "employee_teams": {
            "page": ""
          },
          "employees": {
            "page": ""
          },
          "inventory": {
            "delete": "",
            "list": ""
          },
          "jobs": {
            "admin": "",
            "available-list": "",
            "checklist-view": "",
            "close": "",
            "create": "",
            "deliver": "",
            "detail": "",
            "intake": "",
            "list-active": "",
            "list-all": "",
            "list-ready": "",
            "manual-line": "",
            "partsqueue": "",
            "void": ""
          },
          "owners": {
            "detail": "",
            "list": ""
          },
          "payments": {
            "enter": "",
            "list": ""
          },
          "phonebook": {
            "edit": "",
            "view": ""
          },
          "production": {
            "board": "",
            "list": ""
          },
          "schedule": {
            "view": ""
          },
          "scoreboard": {
            "view": ""
          },
          "shiftclock": {
            "view": ""
          },
          "shop": {
            "config": "",
            "dashboard": "",
            "jobStatus": "",
            "rbac": "",
            "reportcenter": "",
            "responsibilitycenter": "",
            "templates": "",
            "vendors": ""
          },
          "temporarydocs": {
            "view": ""
          },
          "timetickets": {
            "edit": "",
            "editcommitted": "",
            "enter": "",
            "list": "",
            "shiftedit": ""
          },
          "ttapprovals": {
            "approve": "",
            "view": ""
          },
          "users": {
            "editaccess": ""
          }
        },
        "responsibilitycenter": "",
        "responsibilitycenter_accountdesc": "",
        "responsibilitycenter_accountitem": "",
        "responsibilitycenter_accountname": "",
        "responsibilitycenter_accountnumber": "",
        "responsibilitycenter_rate": "",
        "responsibilitycenter_tax_rate": "",
        "responsibilitycenter_tax_sur": "",
        "responsibilitycenter_tax_thres": "",
        "responsibilitycenter_tax_tier": "",
        "responsibilitycenter_tax_type": "",
        "responsibilitycenters": {
          "ap": "",
          "ar": "",
          "ats": "",
          "federal_tax": "",
          "federal_tax_itc": "",
          "gogcode": "",
          "gst_override": "",
          "invoice_federal_tax_rate_short": "",
          "invoice_local_tax_rate_short": "",
          "invoice_state_tax_rate_short": "",
          "invoiceexemptcode": "",
          "invoiceexemptcode_short": "",
          "item_type": "Item Type",
          "item_type_freight": "",
          "item_type_gog": "",
          "item_type_misc": "",
          "item_type_paint": "",
          "itemexemptcode": "",
          "itemexemptcode_short": "",
          "la1": "",
          "la2": "",
          "la3": "",
          "la4": "",
          "laa": "",
          "lab": "",
          "lad": "",
          "lae": "",
          "laf": "",
          "lag": "",
          "lam": "",
          "lar": "",
          "las": "",
          "lau": "",
          "local_tax": "",
          "mapa": "",
          "mash": "",
          "nontaxable": "",
          "paa": "",
          "pac": "",
          "pag": "",
          "pal": "",
          "pam": "",
          "pan": "",
          "pao": "",
          "pap": "",
          "par": "",
          "pas": "",
          "pasl": "",
          "refund": "",
          "sales_tax_codes": {
            "code": "",
            "description": "",
            "federal": "",
            "local": "",
            "state": ""
          },
          "state_tax": "",
          "taxable": "",
          "taxable_flag": "",
          "tow": ""
        },
        "schedule_end_time": "",
        "schedule_start_time": "",
        "scoreboard_setup": {
          "daily_body_target": "",
          "daily_paint_target": "",
          "ignore_blocked_days": "",
          "last_number_working_days": "",
          "production_target_hours": ""
        },
        "shopname": "",
        "speedprint": {
          "id": "",
          "label": "",
          "templates": ""
        },
        "ss_configuration": {
          "dailyhrslimit": "",
          "nobusinessdays": ""
        },
        "ssbuckets": {
          "color": "",
          "gte": "",
          "id": "",
          "label": "",
          "lt": "",
          "target": ""
        },
        "state": "",
        "state_tax_id": "",
        "status": "",
        "statuses": {
          "active_statuses": "",
          "additional_board_statuses": "",
          "color": "",
          "default_arrived": "",
          "default_bo": "",
          "default_canceled": "",
          "default_completed": "",
          "default_delivered": "",
          "default_exported": "",
          "default_imported": "",
          "default_invoiced": "",
          "default_ordered": "",
          "default_quote": "",
          "default_received": "",
          "default_returned": "",
          "default_scheduled": "",
          "default_void": "",
          "open_statuses": "",
          "post_production_statuses": "",
          "pre_production_statuses": "",
          "production_colors": "",
          "production_statuses": "",
          "ready_statuses": ""
        },
        "system_settings": {
          "auto_email": {
            "attach_pdf_to_email": "",
            "from_emails": "",
            "parts_order_cc": "",
            "parts_return_slip_cc": ""
          },
          "job_costing": {
            "paint_hour_split": "",
            "paint_materials_hourly_cost_rate": "",
            "prep_hour_split": "",
            "shop_materials_hourly_cost_rate": "",
            "target_touch_time": "",
            "use_paint_scale_data": ""
          },
          "local_media_server": {
            "enabled": "",
            "http_path": "",
            "network_path": "",
            "token": ""
          },
          "media_tags": "Étiquettes disponibles",
          "media_tags_help": "Ces étiquettes peuvent être attribuées aux fichiers dans la galerie du dossier. Les noms de dossiers système bills, thumbs et ConvertedOriginal ne peuvent pas être utilisés. Les étiquettes attribuées à des fichiers ne peuvent pas être supprimées."
        },
        "target_touchtime": "",
        "timezone": "",
        "tt_allow_post_to_invoiced": "",
        "tt_enforce_hours_for_tech_console": "",
        "tech_console": {
          "inactivity_timeout_enabled": "Activer le délai d’inactivité",
          "inactivity_timeout_enabled_help": "Lorsque cette option est activée, les techniciens inactifs sont automatiquement déconnectés de la console technique.",
          "inactivity_timeout_help": "Le technicien sera déconnecté après ce nombre de minutes sans activité du clavier, du pointeur, de l’écran tactile, de la molette ou du défilement. Entrez une valeur de {{min}} à {{max}} minutes.",
          "inactivity_timeout_minutes": "Délai d’inactivité",
          "inactivity_timeout_validation": "Entrez un nombre entier de {{min}} à {{max}} minutes.",
          "minutes": "minutes"
        },
        "use_fippa": "",
        "use_paint_scale_data": "",
        "uselocalmediaserver": "",
        "website": "",
        "zip_post": ""
      },
      "labels": {
        "2tiername": "",
        "2tiersetup": "",
        "2tiersource": "",
        "accountingsetup": "",
        "accountingtiers": "",
        "alljobstatuses": "",
        "allopenjobstatuses": "",
        "apptcolors": "",
        "autoemail": "",
        "businessinformation": "",
        "checklists": "",
        "consent_settings": "",
        "csiq": "",
        "customtemplates": "",
        "defaultcostsmapping": "",
        "defaultprofitsmapping": "",
        "deliverchecklist": "",
        "dms": {
          "cdk": {
            "controllist": "",
            "payers": ""
          },
          "cdk_dealerid": "",
          "costsmapping": "",
          "dms_allocations": "",
          "pbs_serialnumber": "",
          "profitsmapping": "",
          "rr_dealerid": "",
          "title": ""
        },
        "dms_setup": "",
        "emaillater": "",
        "employee_options": "",
        "employee_rates": "",
        "employee_teams": "",
        "employee_vacation": "",
        "employees": "",
        "estimators": "",
        "filehandlers": "",
        "imexpay": "",
        "insurancecos": "",
        "intake_delivery": "",
        "intakechecklist": "",
        "intellipay_cash_discount": "",
        "job_status_options": "",
        "jobcosting": "",
        "jobstatuses": "",
        "jump_to_section": "",
        "laborrates": "",
        "licensing": "",
        "localmediaserver": "",
        "media_tag_in_use": "Cette étiquette est utilisée et ne peut pas être supprimée.",
        "media_tags": "Étiquettes d’images et de documents",
        "md_parts_scan": "",
        "md_ro_guard": "",
        "md_ro_guard_options": "",
        "md_tasks_presets": "",
        "md_to_emails": "",
        "md_to_emails_emails": "",
        "messagingpresets": "",
        "notemplatesavailable": "",
        "notespresets": "",
        "notification_options": "",
        "notifications": {
          "followers": ""
        },
        "orderstatuses": "",
        "parts_shop_management": "",
        "parts_vendor_management": "",
        "partslocations": "",
        "partsscan": "",
        "printlater": "",
        "qbo": "",
        "qbo_departmentid": "",
        "qbo_usa": "",
        "rbac": "",
        "rbac_options": "",
        "tech_console": "Console technique",
        "tech_console_options": "Options de la console technique",
        "responsibilitycenters": {
          "costs": "",
          "default_tax_setup": "",
          "invoices": "",
          "profits": "",
          "quickbooks_qbd": "",
          "quickbooks_us": "",
          "sales_tax_codes": "",
          "tax_accounts": "",
          "tax_rate_short": "",
          "tax_surcharge_short": "",
          "tax_threshold_short": "",
          "tax_tier_card": "",
          "tax_tier_short": "",
          "tax_type_card": "",
          "title": "",
          "ttl_adjustment": "",
          "ttl_tax_adjustment": ""
        },
        "roguard": {
          "title": ""
        },
        "romepay": "",
        "scheduling": "",
        "scoreboardsetup": "",
        "shop_enabled_features": "",
        "shopinfo": "",
        "shoprates": "",
        "speedprint": "",
        "speedprint_configurations": "",
        "ssbuckets": "",
        "systemsettings": "",
        "task-presets": "",
        "task_preset_options": "",
        "workingdays": ""
      },
      "operations": {
        "contains": "",
        "ends_with": "",
        "equals": "",
        "greater_than": "",
        "less_than": "",
        "not_equals": "",
        "starts_with": ""
      },
      "successes": {
        "areyousure": "",
        "defaultviewcreated": "",
        "save": "",
        "unsavedchanges": ""
      },
      "tooltips": {
        "md_parts_scan": {
          "update_value_tooltip": ""
        },
        "reset-color": ""
      },
      "validation": {
        "centermustexist": "",
        "duplicatecentername": "Un centre de responsabilité portant ce nom existe déjà.",
        "larsplit": "",
        "useremailmustexist": ""
      }
    },
    "checklist": {
      "actions": {
        "printall": ""
      },
      "errors": {
        "complete": "",
        "nochecklist": ""
      },
      "labels": {
        "addtoproduction": "",
        "checklist": "",
        "printpack": "",
        "removefromproduction": ""
      },
      "successes": {
        "completed": ""
      }
    },
    "commandpalette": {
      "hints": {
        "close": "fermer",
        "navigate": "naviguer",
        "select": "ouvrir"
      },
      "noresults": "Aucun résultat pour « {{search}} »",
      "placeholder": "Rechercher des dossiers, clients, véhicules ou taper une commande...",
      "sections": {
        "actions": "Actions rapides",
        "pages": "Aller à la page",
        "recent": "Récents"
      },
      "tooltip": "Recherche et commandes (Ctrl+K)"
    },
    "consent": {
      "associated_owners": "Associated Owners",
      "created_at": "Opt-Out Date",
      "no_owners": "No Associated Owners",
      "phone_1": "Phone 1",
      "phone_2": "Phone 2",
      "phone_number": "Phone Number",
      "text_body": ""
    },
    "contracts": {
      "actions": {
        "changerate": "",
        "convertoro": "",
        "decodelicense": "",
        "find": "",
        "printcontract": "",
        "senddltoform": ""
      },
      "errors": {
        "fetchingjobinfo": "",
        "returning": "",
        "saving": "",
        "selectjobandcar": ""
      },
      "fields": {
        "actax": "",
        "actualreturn": "",
        "agreementnumber": "",
        "cc_cardholder": "",
        "cc_expiry": "",
        "cc_num": "",
        "cleanupcharge": "",
        "coverage": "",
        "dailyfreekm": "",
        "dailyrate": "",
        "damage": "",
        "damagewaiver": "",
        "driver": "",
        "driver_addr1": "",
        "driver_addr2": "",
        "driver_city": "",
        "driver_dlexpiry": "",
        "driver_dlnumber": "",
        "driver_dlst": "",
        "driver_dob": "",
        "driver_fn": "",
        "driver_ln": "",
        "driver_ph1": "",
        "driver_state": "",
        "driver_zip": "",
        "excesskmrate": "",
        "federaltax": "",
        "fuelin": "",
        "fuelout": "",
        "kmend": "",
        "kmstart": "",
        "length": "",
        "localtax": "",
        "refuelcharge": "",
        "scheduledreturn": "",
        "start": "",
        "statetax": "",
        "status": ""
      },
      "labels": {
        "agreement": "",
        "availablecars": "",
        "cardueforservice": "",
        "convertform": {
          "applycleanupcharge": "",
          "refuelqty": ""
        },
        "correctdataonform": "",
        "dateinpast": "",
        "dlexpirebeforereturn": "",
        "driverinformation": "",
        "findcontract": "",
        "findermodal": "",
        "insuranceexpired": "",
        "noteconvertedfrom": "",
        "populatefromjob": "",
        "rates": "",
        "time": "",
        "vehicle": "",
        "waitingforscan": ""
      },
      "status": {
        "new": "",
        "out": "",
        "returned": ""
      },
      "successes": {
        "saved": ""
      }
    },
    "courtesycars": {
      "actions": {
        "new": "",
        "return": ""
      },
      "errors": {
        "saving": ""
      },
      "fields": {
        "color": "",
        "dailycost": "",
        "damage": "",
        "fleetnumber": "",
        "fuel": "",
        "insuranceexpires": "",
        "leaseenddate": "",
        "make": "",
        "mileage": "",
        "model": "",
        "nextservicedate": "",
        "nextservicekm": "",
        "notes": "",
        "plate": "",
        "purchasedate": "",
        "readiness": "",
        "registrationexpires": "",
        "serviceenddate": "",
        "servicestartdate": "",
        "status": "",
        "vin": "",
        "year": ""
      },
      "labels": {
        "courtesycar": "",
        "fuel": {
          "12": "",
          "14": "",
          "18": "",
          "34": "",
          "38": "",
          "58": "",
          "78": "",
          "empty": "",
          "full": ""
        },
        "outwith": "",
        "return": "",
        "status": "",
        "uniquefleet": "",
        "usage": "",
        "vehicle": ""
      },
      "readiness": {
        "notready": "",
        "ready": ""
      },
      "status": {
        "in": "",
        "inservice": "",
        "leasereturn": "",
        "out": "",
        "sold": "",
        "unavailable": ""
      },
      "successes": {
        "saved": ""
      }
    },
    "csi": {
      "actions": {
        "activate": ""
      },
      "errors": {
        "creating": "",
        "notconfigured": "",
        "notfoundsubtitle": "",
        "notfoundtitle": "",
        "surveycompletesubtitle": "",
        "surveycompletetitle": ""
      },
      "fields": {
        "completedon": "",
        "created_at": "",
        "surveyid": "",
        "validuntil": ""
      },
      "labels": {
        "copyright": "",
        "greeting": "",
        "intro": "",
        "nologgedinuser": "",
        "nologgedinuser_sub": "",
        "noneselected": "",
        "title": ""
      },
      "successes": {
        "created": "",
        "submitted": "",
        "submittedsub": ""
      }
    },
    "dashboard": {
      "actions": {
        "addcomponent": ""
      },
      "errors": {
        "atp": "",
        "insco": "",
        "refreshrequired": "",
        "status": "",
        "status_normal": "",
        "updatinglayout": ""
      },
      "labels": {
        "asoftoday": "",
        "attarget": "",
        "belowtarget": "",
        "bodyhrs": "",
        "dollarsinproduction": "",
        "duein": "",
        "efficiencychart": "",
        "emptydeliverytoday": "",
        "emptyhint": "",
        "emptyintoday": "",
        "emptyouttoday": "",
        "emptyproductionstatus": "",
        "hourschart": "",
        "jobs": "",
        "jobscount": "",
        "newperiod": "",
        "overdue": "",
        "overdueby": "",
        "overduecount": "",
        "phone": "",
        "prodhrs": "",
        "prodhrsvstarget": "",
        "refhrs": "",
        "status": "",
        "subtotal": "",
        "tableview": "",
        "targethrs": "",
        "todaycount": "",
        "total": "",
        "tvview": "",
        "vslastmonth": "",
        "vslastyear": "",
        "unknownstatus": ""
      },
      "titles": {
        "joblifecycle": "",
        "labhours": "",
        "larhours": "",
        "monthlyemployeeefficiency": "",
        "monthlyjobcosting": "",
        "monthlylaborsales": "",
        "monthlypartssales": "",
        "monthlyrevenuegraph": "",
        "prodhrssummary": "",
        "productiondollars": "",
        "productionhours": "",
        "productionstatussummary": "",
        "projectedmonthlysales": "",
        "scheduleddeliverydate": "",
        "scheduleddeliverytoday": "",
        "scheduledindate": "",
        "scheduledintoday": "",
        "scheduledoutdate": "",
        "scheduledouttoday": "",
        "tasks": "",
        "yeartodatesales": ""
      }
    },
    "dms": {
      "errors": {
        "alreadyexported": "",
        "earlyrorequired": "",
        "earlyrorequired.message": ""
      },
      "labels": {
        "banner_message": "",
        "banner_status_connected": "",
        "banner_status_disconnected": "",
        "clear_logs": "",
        "collapse_all": "",
        "color_json": "",
        "copied": "",
        "copy": "",
        "copy_request": "",
        "copy_response": "",
        "details": "",
        "expand_all": "",
        "hide_details": "",
        "log_level": "",
        "plain_json": "",
        "provider_cdk": "",
        "provider_dms": "",
        "provider_fortellis": "",
        "provider_pbs": "",
        "provider_reynolds": "",
        "reconnect": "",
        "reconnected_export_service": "",
        "refreshallocations": "",
        "request_xml": "",
        "response_xml": "",
        "rr_validation_message": "",
        "rr_validation_notice_description": "",
        "rr_validation_notice_title": "",
        "transport_ws": "",
        "transport_wss": ""
      },
      "rr_allocations_preview": {
        "columns": {
          "amt_type": "",
          "bill_rate": "",
          "bill_time": "",
          "break_out": "",
          "code_amt": "",
          "cust_pay_type": "",
          "cust_price": "",
          "cust_qty": "",
          "cust_txbl_flag": "",
          "dlr_cost": "",
          "item_desc": "",
          "item_type": "",
          "job_no": "",
          "job_total_hrs": "",
          "misc_code": "",
          "op_code": "",
          "pay_type": "",
          "total_amt": ""
        },
        "descriptions": {
          "gog": "",
          "labor": "",
          "misc": ""
        },
        "empty": {
          "gog": "",
          "labor": "",
          "misc": ""
        },
        "labels": {
          "op_code": ""
        },
        "segments": {
          "extras_non_taxable": "",
          "extras_taxable": "",
          "labor_non_taxable": "",
          "labor_taxable": "",
          "parts_non_taxable": "",
          "parts_taxable": ""
        },
        "tabs": {
          "gog": "",
          "labor": "",
          "misc": ""
        }
      }
    },
    "documents": {
      "actions": {
        "delete": "Supprimer les fichiers sélectionnés",
        "download": "Télécharger les fichiers sélectionnés",
        "reassign": "",
        "selectfiles": "Sélectionner des fichiers",
        "selectallimages": "Sélectionner toutes les images",
        "selectallotherdocuments": "Sélectionner tous les documents",
        "applytag": "Appliquer les étiquettes"
      },
      "errors": {
        "deletes3": "Erreur lors de la suppression du document du stockage.",
        "deleting": "",
        "deleting_cloudinary": "",
        "getpresignurl": "Erreur lors de l'obtention de l'URL présignée pour le document. {{message}}",
        "insert": "Incapable de télécharger le fichier. {{message}}",
        "lms_mobile_browser": "Les images du serveur multimédia local ne sont pas disponibles dans un navigateur mobile. Utilisez l’application mobile pour les consulter ou les joindre.",
        "lms_unavailable": "Impossible de charger les images du serveur multimédia local. Vérifiez votre connexion au réseau de l’atelier et réessayez.",
        "nodocuments": "Il n'y a pas de documents.",
        "updating": ""
      },
      "labels": {
        "confirmdelete": "Voulez-vous vraiment supprimer ces fichiers? Cette action est irréversible.",
        "alltags": "Toutes les étiquettes",
        "doctype": "",
        "dragtoupload": "",
        "fileactions": "Accès aux fichiers",
        "greyscale": "Niveaux de gris",
        "filtertag": "Filtrer par étiquette",
        "lightboxtag": "Étiquette : {{tag}}",
        "newjobid": "",
        "openinexplorer": "",
        "optimizedimage": "",
        "reassign_limitexceeded": "",
        "reassign_limitexceeded_title": "",
        "storageexceeded": "",
        "storageexceeded_title": "",
        "selecttag": "Sélectionner une étiquette",
        "selectedactions": "Fichiers sélectionnés",
        "selectionactions": "Sélection",
        "tagassignment": "Appliquer les étiquettes",
        "tagfilter": "Filtrer par étiquette",
        "untagged": "Sans étiquette",
        "upload": "Télécharger",
        "upload_limitexceeded": "",
        "upload_limitexceeded_title": "",
        "uploading": "",
        "usage": ""
      },
      "successes": {
        "delete": "Le document a bien été supprimé.",
        "edituploaded": "Le document modifié a bien été téléversé. Vous pouvez maintenant fermer cette fenêtre.",
        "insert": "Document téléchargé avec succès.",
        "updated": ""
      }
    },
    "emails": {
      "errors": {
        "notsent": "Courriel non envoyé. Erreur rencontrée lors de l'envoi de {{message}}"
      },
      "fields": {
        "cc": "",
        "from": "",
        "subject": "",
        "to": ""
      },
      "labels": {
        "attachments": "",
        "documents": "",
        "emailpreview": "",
        "generatingemail": "",
        "pdfcopywillbeattached": "",
        "preview": ""
      },
      "successes": {
        "sent": "E-mail envoyé avec succès."
      }
    },
    "employee_teams": {
      "actions": {
        "new": "",
        "newmember": "",
        "save_team": ""
      },
      "errors": {
        "allocation_total_exact": "",
        "duplicate_member": "",
        "minimum_one_member": ""
      },
      "fields": {
        "active": "",
        "allocation": "",
        "allocation_percentage": "",
        "employeeid": "",
        "max_load": "",
        "name": "",
        "payout_method": "",
        "percentage": ""
      },
      "labels": {
        "allocation_total": "",
        "members": "",
        "team_options": ""
      },
      "options": {
        "commission": "",
        "commission_percentage": "",
        "hourly": ""
      }
    },
    "employees": {
      "actions": {
        "addrate": "",
        "addvacation": "",
        "new": "Nouvel employé",
        "newrate": "",
        "save_employee": "",
        "select": ""
      },
      "errors": {
        "delete": "Erreur rencontrée lors de la suppression de l'employé. {{message}}",
        "save": "Une erreur s'est produite lors de l'enregistrement de l'employé. {{message}}",
        "validation": "Veuillez cocher tous les champs.",
        "validationtitle": "Impossible d'enregistrer l'employé."
      },
      "fields": {
        "active": "Actif?",
        "base_rate": "Taux de base",
        "cost_center": "Centre de coûts",
        "employee_number": "Numéro d'employé",
        "external_id": "",
        "external_rate_code": "Code de tarif externe",
        "first_name": "Prénom",
        "flat_rate": "Taux fixe (désactivé est le temps normal)",
        "hire_date": "Date d'embauche",
        "last_name": "Nom de famille",
        "pin": "",
        "rate": "",
        "termination_date": "Date de résiliation",
        "user_email": "",
        "vacation": {
          "end": "",
          "length": "",
          "start": ""
        }
      },
      "labels": {
        "actions": "",
        "active": "",
        "employee_number_short": "",
        "endmustbeafterstart": "",
        "flat_rate": "",
        "inactive": "",
        "name": "",
        "rate_type": "",
        "status": "",
        "straight_time": ""
      },
      "successes": {
        "delete": "L'employé a bien été supprimé.",
        "save": "L'employé a enregistré avec succès.",
        "vacationadded": ""
      },
      "validation": {
        "unique_employee_number": "",
        "unique_user_email": "Cette adresse courriel est déjà assignée à un autre employé."
      }
    },
    "esignature": {
      "actions": {
        "delete": "",
        "distribute": "",
        "redistribute": "",
        "upload_document": "Upload Document for E-Sign",
        "view": ""
      },
      "errors": {
        "no_token": "",
        "pdf_only": "Only PDF documents can be uploaded for e-signature.",
        "upload_title": "Unable to prepare document for e-signature"
      },
      "confirm": {
        "discard_title": "Abandonner ce document ?",
        "discard_content": "Le document televerse et tous les champs que vous avez places seront definitivement supprimes du serveur de signature.",
        "discard_ok": "Abandonner",
        "discard_cancel": "Continuer l'edition"
      },
      "tooltips": {
        "contact_sales": "Les signatures electroniques ne sont pas activees pour cet atelier. Contactez les ventes pour ajouter cette fonctionnalite.",
        "distribute_checking": "Verification du statut du document...",
        "distribute_incomplete": "Terminez la configuration du document dans l'editeur et cliquez sur Enregistrer avant de distribuer.",
        "distribute_missing_fields": "Ajoutez un champ de signature pour {{recipients}} dans l'editeur, puis cliquez sur Enregistrer pour activer la distribution."
      },
      "fields": {
        "completed": "",
        "completed_at": "",
        "created_at": "",
        "external_document_id": "",
        "opened": "",
        "rejected": "",
        "status": "",
        "title": "",
        "updated_at": ""
      }
    },
    "eula": {
      "buttons": {
        "accept": "Accept EULA"
      },
      "content": {
        "never_scrolled": "You must scroll to the bottom of the Terms and Conditions before accepting."
      },
      "errors": {
        "acceptance": {
          "description": "Something went wrong while accepting the EULA. Please try again.",
          "message": "Eula Acceptance Error"
        }
      },
      "labels": {
        "accepted_terms": "I accept the terms and conditions of this agreement.",
        "address": "Address",
        "business_name": "Legal Business Name",
        "date_accepted": "Date Accepted",
        "first_name": "First Name",
        "last_name": "Last Name",
        "phone_number": "Phone Number"
      },
      "messages": {
        "accepted_terms": "Please accept the terms and conditions of this agreement.",
        "business_name": "Please enter your legal business name.",
        "date_accepted": "Please enter Today's Date.",
        "first_name": "Please enter your first name.",
        "last_name": "Please enter your last name.",
        "phone_number": "Please enter your phone number."
      },
      "titles": {
        "modal": "Terms and Conditions",
        "upper_card": "Acknowledgement"
      }
    },
    "exportlogs": {
      "fields": {
        "createdat": ""
      },
      "labels": {
        "attempts": "",
        "priorsuccesfulexport": ""
      }
    },
    "general": {
      "actions": {
        "add": "",
        "addtoproduction": "",
        "autoupdate": "",
        "calculate": "",
        "cancel": "Annuler",
        "clear": "",
        "connectquickbooks": "Connect to QuickBooks",
        "close": "Fermer",
        "copied": "",
        "copylink": "",
        "create": "",
        "defaults": "Par défaut",
        "delay": "",
        "delete": "Effacer",
        "deleteall": "",
        "deselectall": "Tout désélectionner",
        "done": "",
        "download": "",
        "edit": "modifier",
        "fliphorizontal": "Retourner horizontalement",
        "flipvertical": "Retourner verticalement",
        "gotoadmin": "",
        "login": "",
        "next": "",
        "ok": "",
        "optional": "",
        "or": "or",
        "previous": "",
        "print": "",
        "refresh": "Actualiser",
        "remove": "",
        "remove_alert": "",
        "reset": " Rétablir l'original.",
        "resetpassword": "",
        "rotateleft": "Pivoter à gauche",
        "rotateright": "Pivoter à droite",
        "save": "sauvegarder",
        "saveandnew": "",
        "saveas": "Enregistrer sous",
        "select": "",
        "selectall": "Tout sélectionner",
        "send": "",
        "sendbysms": "",
        "senderrortosupport": "",
        "sharetoteams": "",
        "submit": "",
        "tryagain": "",
        "view": "",
        "viewreleasenotes": "",
        "zoomin": "Zoom avant",
        "zoomout": "Zoom arrière"
      },
      "errors": {
        "fcm": "",
        "notfound": "",
        "sizelimit": "",
        "sub_status": {
          "expired": "",
          "trial-expired": "",
          "undefined": ""
        },
        "submit-for-testing": ""
      },
      "itemtypes": {
        "contract": "",
        "courtesycar": "",
        "job": "",
        "owner": "",
        "vehicle": ""
      },
      "labels": {
        "actions": "actes",
        "apply": "",
        "areyousure": "",
        "barcode": "code à barre",
        "beta": "",
        "cancel": "",
        "changelog": "",
        "clear": "",
        "click_to_begin": "",
        "confirmpassword": "",
        "created_at": "",
        "date": "",
        "datetime": "",
        "email": "",
        "errors": "",
        "excel": "",
        "exceptiontitle": "",
        "feature-request": "",
        "friday": "",
        "globalsearch": "",
        "help": "",
        "hours": "",
        "in": "dans",
        "instanceconflictext": "",
        "instanceconflictitle": "",
        "item": "",
        "label": "",
        "loading": "Chargement...",
        "loadingapp": "Chargement de {{app}}",
        "loadingshop": "Chargement des données de la boutique ...",
        "loggingin": "Vous connecter ...",
        "markedexported": "",
        "media": "",
        "message": "",
        "monday": "",
        "na": "N / A",
        "newpassword": "",
        "no": "",
        "nointernet": "",
        "nointernet_sub": "",
        "none": "",
        "out": "En dehors",
        "password": "",
        "passwordresetsuccess": "",
        "passwordresetsuccess_sub": "",
        "passwordresetvalidatesuccess": "",
        "passwordresetvalidatesuccess_sub": "",
        "passwordsdonotmatch": "",
        "print": "",
        "refresh": "",
        "reports": "",
        "required": "",
        "saturday": "",
        "search": "Chercher...",
        "searchresults": "",
        "selectdate": "",
        "selected": "",
        "sendagain": "",
        "sendby": "",
        "settings": "",
        "signin": "",
        "sms": "",
        "status": "",
        "sub_status": {
          "expired": ""
        },
        "successful": "",
        "sunday": "",
        "text": "",
        "thursday": "",
        "time": "",
        "total": "",
        "totals": "",
        "tuesday": "",
        "tvmode": "",
        "unknown": "Inconnu",
        "unsavedchanges": "Modifications non enregistrées",
        "username": "",
        "validationerror": "",
        "view": "",
        "wednesday": "",
        "yes": ""
      },
      "languages": {
        "english": "Anglais",
        "french": "Francais",
        "spanish": "Espanol"
      },
      "messages": {
        "exception": "",
        "newversionmessage": "",
        "newversiontitle": "",
        "noacctfilepath": "",
        "nofeatureaccess": "",
        "noshop": "",
        "notfoundsub": "",
        "notfoundtitle": "",
        "partnernotrunning": "",
        "rbacunauth": "",
        "submit-for-testing": "",
        "unsavedchanges": "Vous avez des changements non enregistrés.",
        "unsavedchangespopup": "Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter?"
      },
      "validation": {
        "array": "Veuillez sélectionner au moins une option.",
        "dateRangeExceeded": "",
        "invalidemail": "S'il vous plaît entrer un email valide.",
        "invalidphone": "",
        "minlength": "Doit contenir au moins {{min}} caractères.",
        "required": "Ce champ est requis."
      }
    },
    "help": {
      "actions": {
        "connect": ""
      },
      "labels": {
        "codeplacholder": "",
        "rescuedesc": "",
        "rescuetitle": ""
      }
    },
    "intake": {
      "labels": {
        "printpack": ""
      }
    },
    "inventory": {
      "actions": {
        "addtoinventory": "",
        "addtoro": "",
        "consumefrominventory": "",
        "edit": "",
        "new": ""
      },
      "errors": {
        "inserting": ""
      },
      "fields": {
        "comment": "",
        "manualinvoicenumber": "",
        "manualvendor": ""
      },
      "labels": {
        "consumedbyjob": "",
        "deleteconfirm": "",
        "frombillinvoicenumber": "",
        "fromvendor": "",
        "inventory": "",
        "showall": "",
        "showavailable": ""
      },
      "successes": {
        "deleted": "",
        "inserted": "",
        "updated": ""
      }
    },
    "job_lifecycle": {
      "columns": {
        "average_human_readable": "",
        "average_value": "",
        "duration": "",
        "end": "",
        "human_readable": "",
        "percentage": "",
        "relative_end": "",
        "relative_start": "",
        "start": "",
        "status": "",
        "status_count": "",
        "value": ""
      },
      "content": {
        "calculated_based_on": "",
        "current_status_accumulated_time": "",
        "data_unavailable": "",
        "jobs_in_since": "",
        "legend_title": "",
        "loading": "",
        "not_available": "",
        "previous_status_accumulated_time": "",
        "title": "",
        "title_durations": "",
        "title_loading": "",
        "title_transitions": ""
      },
      "errors": {
        "fetch": "Erreur lors de l'obtention des données du cycle de vie des tâches"
      },
      "titles": {
        "dashboard": "",
        "top_durations": ""
      }
    },
    "job_payments": {
      "buttons": {
        "create_short_link": "",
        "goback": "",
        "proceedtopayment": "",
        "refundpayment": ""
      },
      "notifications": {
        "error": {
          "description": "",
          "openingip": "",
          "title": ""
        }
      },
      "titles": {
        "amount": "",
        "dateOfPayment": "",
        "descriptions": "",
        "hint": "",
        "payer": "",
        "payername": "",
        "paymentid": "",
        "paymentnum": "",
        "paymenttype": "",
        "refundamount": "",
        "transactionid": ""
      }
    },
    "joblines": {
      "actions": {
        "assign_team": "",
        "converttolabor": "",
        "dispatchparts": "",
        "new": "",
        "revertprice": "Rétablir",
        "save_add_another": "Enregistrer et ajouter une autre",
        "updatelocation": ""
      },
      "errors": {
        "creating": "",
        "updating": ""
      },
      "fields": {
        "act_price": "Prix actuel",
        "act_price_before_ppc": "",
        "adjustment": "",
        "ah_detail_line": "",
        "alt_partno": "",
        "amount": "",
        "assigned_team": "",
        "assigned_team_name": "",
        "cost_only": "Coût seulement",
        "create_ppc": "",
        "db_price": "Prix de la base de données",
        "include_in_part_cnt": "",
        "lbr_types": {
          "LA1": "",
          "LA2": "",
          "LA3": "",
          "LA4": "",
          "LAA": "",
          "LAB": "",
          "LAD": "",
          "LAE": "",
          "LAF": "",
          "LAG": "",
          "LAM": "",
          "LAR": "",
          "LAS": "",
          "LAU": ""
        },
        "line_desc": "Description de la ligne",
        "line_ind": "S#",
        "line_kind": "Type de ligne",
        "line_no": "",
        "location": "",
        "mod_lb_hrs": "Heures de travail",
        "mod_lbr_ty": "Type de travail",
        "notes": "",
        "oem_partno": "Pièce OEM #",
        "op_code_desc": "",
        "part_qty": "",
        "part_type": "Type de pièce",
        "part_types": {
          "CCC": "",
          "CCD": "",
          "CCDR": "",
          "CCF": "",
          "CCM": "",
          "PAA": "",
          "PAC": "",
          "PAE": "",
          "PAG": "",
          "PAL": "",
          "PAM": "",
          "PAN": "",
          "PAO": "",
          "PAP": "",
          "PAR": "",
          "PAS": "",
          "PASL": ""
        },
        "profitcenter_labor": "",
        "profitcenter_part": "",
        "prt_dsmk_m": "",
        "prt_dsmk_p": "",
        "status": "Statut",
        "tax_part": "",
        "total": "",
        "unq_seq": "Seq #"
      },
      "kinds": {
        "both": "Main-d'œuvre + pièce",
        "fee": "Frais / autre",
        "labor": "Main-d'œuvre",
        "part": "Pièce"
      },
      "labels": {
        "adjustmenttobeadded": "",
        "ah_detail_line_help": "Disponible pour les types de main-d'œuvre définis par l'utilisateur (LA1–LA4, LAU).",
        "apply_preset": "Appliquer un préréglage…",
        "billref": "",
        "bulk_location_help": "",
        "convertedtolabor": "",
        "cost_only_banner": "Cette ligne est exclue des totaux et des taxes, mais demeure visible dans la commande de pièces et la main-d'œuvre. Elle est surlignée en orange dans le tableau des lignes d'estimation.",
        "cost_only_help": "Les lignes de coût seulement sont exclues des totaux du travail, mais demeurent visibles dans les pièces et la main-d'œuvre.",
        "discount_applied": "= {{amount}} appliqué à cette ligne",
        "discount_markup": "Remise / majoration",
        "edit": "Ligne d'édition",
        "excluded_from_totals": "Exclu des totaux",
        "hours_required_hint": "Requis lorsqu'un type de main-d'œuvre est sélectionné",
        "include_in_part_cnt_help": "Disponible lorsque le prix de détail est de 0,00 $.",
        "ioucreated": "",
        "manuallineprice": "Les lignes manuelles sont tarifées à partir de l'action de modification de la ligne, pas de cette fenêtre contextuelle.",
        "new": "Nouvelle ligne",
        "nostatus": "",
        "not_set_by_preset": "Non défini par ce préréglage",
        "preset_applied": "Préréglage appliqué — les champs surlignés ont été remplis par {{label}}; tout demeure modifiable.",
        "presets": "",
        "tax_part_help": "Inclure cette ligne dans le calcul des taxes."
      },
      "sections": {
        "fee": "Montant",
        "labor": "Main-d'œuvre",
        "line": "Détails de la ligne",
        "options": "Options",
        "parts": "Pièces et prix"
      },
      "successes": {
        "created": "",
        "saved": "",
        "updated": ""
      },
      "validations": {
        "ahdetailonlyonuserdefinedtypes": "",
        "hrsrequirediflbrtyp": "",
        "requiredifparttype": "",
        "zeropriceexistingpart": ""
      }
    },
    "jobs": {
      "actions": {
        "addDocuments": "Ajouter des documents de travail",
        "addNote": "Ajouter une note",
        "addpayer": "",
        "addtopartsqueue": "",
        "removefrompartsqueue": "Retirer de la file d'attente des pièces",
        "addtoproduction": "",
        "addtoscoreboard": "",
        "allocate": "",
        "autoallocate": "",
        "changefilehandler": "",
        "changelaborrate": "",
        "changestatus": "Changer le statut",
        "changestimator": "",
        "convert": "Convertir",
        "convertwithoutearlyro": "",
        "createiou": "",
        "deliver": "",
        "deliver_quick": "",
        "dms": {
          "addpayer": "",
          "createearlyro": "",
          "createnewcustomer": "",
          "findmakemodelcode": "",
          "getmakes": "",
          "labels": {
            "refreshallocations": ""
          },
          "post": "",
          "refetchmakesmodels": "",
          "update_ro": "",
          "usegeneric": "",
          "useselected": ""
        },
        "dmsautoallocate": "",
        "export": "",
        "exportcustdata": "",
        "exportselected": "",
        "filterpartsonly": "",
        "generatecsi": "",
        "gotojob": "",
        "intake": "",
        "intake_quick": "",
        "manualnew": "",
        "mark": "",
        "markasexported": "",
        "markpstexempt": "",
        "markpstexemptconfirm": "",
        "postbills": "Poster des factures",
        "printCenter": "Centre d'impression",
        "recalculate": "",
        "reconcile": "",
        "removefromproduction": "",
        "schedule": "Programme",
        "sendcsi": "",
        "sendpartspricechange": "",
        "sendtodms": "",
        "sync": "",
        "taxprofileoverride": "",
        "taxprofileoverride_confirm": "",
        "uninvoice": "",
        "unvoid": "",
        "viewchecklist": "",
        "viewdetail": ""
      },
      "errors": {
        "addingtoproduction": "",
        "cannotintake": "",
        "closing": "",
        "creating": "",
        "deleted": "Erreur lors de la suppression du travail.",
        "exporting": "",
        "exporting-partner": "",
        "invalidjoblines": "",
        "invoicing": "",
        "missingjoblineids": "",
        "noaccess": "Ce travail n'existe pas ou vous n'y avez pas accès.",
        "nodamage": "",
        "nodates": "Aucune date spécifiée pour ce travail.",
        "nofinancial": "",
        "nojobselected": "Aucun travail n'est sélectionné.",
        "noowner": "Aucun propriétaire associé.",
        "novehicle": "Aucun véhicule associé.",
        "partspricechange": "",
        "saving": "Erreur rencontrée lors de la sauvegarde de l'enregistrement.",
        "scanimport": "",
        "totalscalc": "",
        "updating": "",
        "validation": "Veuillez vous assurer que tous les champs sont correctement entrés.",
        "validationtitle": "Erreur de validation",
        "voiding": ""
      },
      "fields": {
        "active_tasks": "",
        "actual_completion": "Achèvement réel",
        "actual_delivery": "Livraison réelle",
        "actual_in": "En réel",
        "acv_amount": "",
        "adjustment_bottom_line": "Ajustements",
        "adjustmenthours": "",
        "admin_clerk": "",
        "alt_transport": "",
        "area_of_damage_impact": {
          "10": "",
          "11": "",
          "12": "",
          "13": "",
          "14": "",
          "15": "",
          "16": "",
          "25": "",
          "26": "",
          "27": "",
          "28": "",
          "34": "",
          "01": "",
          "02": "",
          "03": "",
          "04": "",
          "05": "",
          "06": "",
          "07": "",
          "08": "",
          "09": ""
        },
        "auto_add_ats": "",
        "ca_bc_pvrt": "",
        "ca_customer_gst": "",
        "ca_gst_registrant": "",
        "category": "",
        "ccc": "",
        "ccd": "",
        "ccdr": "",
        "ccf": "",
        "ccm": "",
        "cieca_id": "CIECA ID",
        "cieca_pfl": {
          "lbr_adjp": "",
          "lbr_tax_in": "",
          "lbr_taxp": "",
          "lbr_tx_in1": "",
          "lbr_tx_in2": "",
          "lbr_tx_in3": "",
          "lbr_tx_in4": "",
          "lbr_tx_in5": ""
        },
        "cieca_pfo": {
          "stor_t_in1": "",
          "stor_t_in2": "",
          "stor_t_in3": "",
          "stor_t_in4": "",
          "stor_t_in5": "",
          "tow_t_in1": "",
          "tow_t_in2": "",
          "tow_t_in3": "",
          "tow_t_in4": "",
          "tow_t_in5": ""
        },
        "claim_total": "Total réclamation",
        "class": "",
        "clm_no": "Prétendre #",
        "clm_total": "Total réclamation",
        "comment": "",
        "customerowing": "Client propriétaire",
        "date_estimated": "Date estimée",
        "date_exported": "Exportés",
        "date_invoiced": "Facturé",
        "date_last_contacted": "",
        "date_lost_sale": "",
        "date_next_contact": "",
        "date_open": "Ouvrir",
        "date_rentalresp": "",
        "date_repairstarted": "",
        "date_scheduled": "Prévu",
        "date_towin": "",
        "date_void": "",
        "ded_amt": "Déductible",
        "ded_note": "",
        "ded_status": "Statut de franchise",
        "depreciation_taxes": "Amortissement / taxes",
        "dms": {
          "IsARCustomer": "",
          "address": "",
          "advisor": "",
          "amount": "",
          "center": "",
          "control_type": {
            "account_number": ""
          },
          "cost": "",
          "cost_dms_acctnumber": "",
          "customer": "",
          "dms_make": "",
          "dms_model": "",
          "dms_model_override": "",
          "dms_unsold": "",
          "dms_wip_acctnumber": "",
          "first_name": "",
          "id": "",
          "inservicedate": "",
          "journal": "",
          "last_name": "",
          "lines": "",
          "make_override": "",
          "name1": "",
          "payer": {
            "amount": "",
            "control_type": "",
            "controlnumber": "",
            "dms_acctnumber": "",
            "name": "",
            "payer_type": ""
          },
          "rr_opcode": "",
          "rr_opcode_base": "",
          "rr_opcode_prefix": "",
          "rr_opcode_suffix": "",
          "sale": "",
          "sale_dms_acctnumber": "",
          "story": "",
          "vinowner": ""
        },
        "dms_allocation": "",
        "driveable": "",
        "employee_body": "",
        "employee_csr": "représentant du service à la clientèle",
        "employee_csr_writer": "",
        "employee_prep": "",
        "employee_refinish": "",
        "est_addr1": "Adresse de l'évaluateur",
        "est_co_nm": "Expert",
        "est_co_nm_short": "",
        "est_ct_fn": "Prénom de l'évaluateur",
        "est_ct_fn_short": "",
        "est_ct_ln": "Nom de l'évaluateur",
        "est_ct_ln_short": "",
        "est_ea": "Courriel de l'évaluateur",
        "est_ea_short": "",
        "est_ph1": "Numéro de téléphone de l'évaluateur",
        "est_ph1_short": "",
        "estimate_approved": "",
        "estimate_sent_approval": "",
        "federal_tax_payable": "Impôt fédéral à payer",
        "federal_tax_rate": "",
        "flat_rate_ats": "",
        "hit_and_run": "",
        "ins_addr1": "Adresse Insurance Co.",
        "ins_city": "Insurance City",
        "ins_co_id": "ID de la compagnie d'assurance",
        "ins_co_nm": "Nom de la compagnie d'assurance",
        "ins_co_nm_short": "",
        "ins_ct_fn": "Prénom du gestionnaire de fichiers",
        "ins_ct_fn_short": "",
        "ins_ct_ln": "Nom du gestionnaire de fichiers",
        "ins_ct_ln_short": "",
        "ins_ea": "Courriel du gestionnaire de fichiers",
        "ins_ea_short": "",
        "ins_ph1": "Numéro de téléphone du gestionnaire de fichiers",
        "ins_ph1_short": "",
        "intake": {
          "label": "",
          "max": "",
          "min": "",
          "name": "",
          "required": "",
          "type": ""
        },
        "invoice_final_note": "",
        "kmin": "Kilométrage en",
        "kmout": "Kilométrage hors",
        "la1": "",
        "la2": "",
        "la3": "",
        "la4": "",
        "laa": "",
        "lab": "",
        "labor_rate_desc": "Nom du taux de main-d'œuvre",
        "lad": "",
        "lae": "",
        "laf": "",
        "lag": "",
        "lam": "",
        "lar": "",
        "las": "",
        "lau": "",
        "local_tax_rate": "",
        "loss_date": "Date de perte",
        "loss_desc": "",
        "loss_of_use": "",
        "lost_sale_reason": "",
        "ma2s": "",
        "ma3s": "",
        "mabl": "",
        "macs": "",
        "mahw": "",
        "mapa": "",
        "mash": "",
        "matd": "",
        "materials": {
          "MAPA": "",
          "MASH": "",
          "cal_maxdlr": "",
          "cal_opcode": "",
          "mat_adjp": "",
          "mat_taxp": "",
          "mat_tx_in1": "",
          "mat_tx_in2": "",
          "mat_tx_in3": "",
          "mat_tx_in4": "",
          "mat_tx_in5": "",
          "materials": "",
          "tax_ind": ""
        },
        "other_amount_payable": "Autre montant à payer",
        "owner": "Propriétaire",
        "owner_owing": "Cust. Owes",
        "ownr_ea": "Email",
        "ownr_ph1": "Téléphone 1",
        "ownr_ph2": "",
        "paa": "",
        "pac": "",
        "pae": "",
        "pag": "",
        "pal": "",
        "pam": "",
        "pan": "",
        "pao": "",
        "pap": "",
        "par": "",
        "parts_tax_rates": {
          "prt_discp": "",
          "prt_mktyp": "",
          "prt_mkupp": "",
          "prt_tax_in": "",
          "prt_tax_rt": "",
          "prt_tx_in1": "",
          "prt_tx_in2": "",
          "prt_tx_in3": "",
          "prt_tx_in4": "",
          "prt_tx_in5": "",
          "prt_tx_ty1": "",
          "prt_type": ""
        },
        "partsstatus": "",
        "pas": "",
        "pay_date": "Date d'Pay",
        "phoneshort": "PH",
        "po_number": "",
        "policy_no": "Politique #",
        "ponumber": "Numéro de bon de commande",
        "production_vars": {
          "note": ""
        },
        "qb_multiple_payers": {
          "amount": "",
          "name": ""
        },
        "queued_for_parts": "",
        "rate_ats": "",
        "rate_ats_flat": "",
        "rate_la1": "Taux LA1",
        "rate_la2": "Taux LA2",
        "rate_la3": "Taux LA3",
        "rate_la4": "Taux LA4",
        "rate_laa": "Taux d'aluminium",
        "rate_lab": "Taux de la main-d'œuvre",
        "rate_lad": "Taux de diagnostic",
        "rate_lae": "Tarif électrique",
        "rate_laf": "Taux de trame",
        "rate_lag": "Taux de verre",
        "rate_lam": "Taux mécanique",
        "rate_lar": "Taux de finition",
        "rate_las": "",
        "rate_lau": "Taux d'aluminium",
        "rate_ma2s": "Taux de peinture en 2 étapes",
        "rate_ma3s": "Taux de peinture en 3 étapes",
        "rate_mabl": "MABL ??",
        "rate_macs": "MACS ??",
        "rate_mahw": "Taux de déchets dangereux",
        "rate_mapa": "Taux de matériaux de peinture",
        "rate_mash": "Tarif du matériel de la boutique",
        "rate_matd": "Taux d'élimination des pneus",
        "referral_source_extra": "",
        "referral_source_other": "",
        "referralsource": "Source de référence",
        "regie_number": "Enregistrement #",
        "repairtotal": "Réparation totale",
        "ro_number": "RO #",
        "scheduled_completion": "Achèvement planifié",
        "scheduled_delivery": "Livraison programmée",
        "scheduled_in": "Planifié dans",
        "selling_dealer": "Revendeur vendeur",
        "selling_dealer_contact": "Contacter le revendeur",
        "servicecar": "Voiture de service",
        "servicing_dealer": "Concessionnaire",
        "servicing_dealer_contact": "Contacter le concessionnaire",
        "special_coverage_policy": "Politique de couverture spéciale",
        "specialcoveragepolicy": "Politique de couverture spéciale",
        "state_tax_rate": "",
        "status": "Statut de l'emploi",
        "storage_payable": "Stockage",
        "tax_lbr_rt": "",
        "tax_levies_rt": "",
        "tax_paint_mat_rt": "",
        "tax_registration_number": "",
        "tax_shop_mat_rt": "",
        "tax_str_rt": "",
        "tax_sub_rt": "",
        "tax_tow_rt": "",
        "tlos_ind": "",
        "towin": "",
        "towing_payable": "Remorquage à payer",
        "unitnumber": "Unité #",
        "updated_at": "Mis à jour à",
        "uploaded_by": "Telechargé par",
        "vehicle": "Véhicule"
      },
      "forms": {
        "admindates": "",
        "appraiserinfo": "",
        "claiminfo": "",
        "estdates": "",
        "laborrates": "",
        "lossinfo": "",
        "other": "",
        "repairdates": "",
        "scheddates": ""
      },
      "labels": {
        "esignatures": "",
        "accountsreceivable": "",
        "act_price_ppc": "",
        "actual_completion_inferred": "",
        "actual_delivery_inferred": "",
        "actual_in_inferred": "",
        "additionalpayeroverallocation": "",
        "additionaltotal": "",
        "adjustmentrate": "",
        "adjustments": "",
        "adminwarning": "",
        "allocations": "",
        "alreadyaddedtoscoreboard": "",
        "alreadyclosed": "",
        "appointmentconfirmation": "Envoyer une confirmation au client?",
        "approved": "",
        "associationwarning": "",
        "audit": "",
        "available": "",
        "availablejobs": "",
        "ca_bc_pvrt": {
          "days": "",
          "rate": ""
        },
        "ca_gst_all_if_null": "",
        "calc_repair_days": "",
        "calc_repair_days_tt": "",
        "calc_scheuled_completion": "",
        "cards": {
          "customer": "Informations client",
          "damage": "Zone de dommages",
          "dates": "Rendez-vous",
          "documents": "Documents récents",
          "estimator": "Estimateur",
          "filehandler": "Gestionnaire de fichiers",
          "insurance": "Détails de l'assurance",
          "more": "Plus",
          "notes": "Remarques",
          "parts": "les pièces",
          "totals": "Totaux",
          "vehicle": "Véhicule"
        },
        "changeclass": "",
        "checklistcompletedby": "",
        "checklistdocuments": "",
        "checklists": "",
        "cieca_pfl": "",
        "cieca_pfo": "",
        "cieca_pft": "",
        "closeconfirm": "",
        "closejob": "",
        "closingperiod": "",
        "contracts": "",
        "convert": {
          "driveabledesc": "Le véhicule peut quitter l'atelier par ses propres moyens une fois les réparations terminées.",
          "earlyrogatedesc": "Cet atelier transmet les données à Reynolds & Reynolds. Réservez d'abord un numéro de RO ci-dessous — le reste de ce formulaire se débloque une fois qu'il est créé.",
          "earlyrogatefooterhint": "Créez le RO préliminaire ci-dessus avant de convertir.",
          "earlyrogatetitle": "RO préliminaire requis avant la conversion",
          "gstdesc": "Le client est inscrit à la TPS — modifie le calcul des taxes sur ce RO.",
          "requirements": "Exigences de conversion",
          "towindesc": "Le véhicule est arrivé remorqué et ne peut pas être conduit dans son état actuel.",
          "vehiclestatus": "État du véhicule et facturation"
        },
        "convertedtolabor": "",
        "cost": "",
        "cost_Additional": "",
        "cost_labor": "",
        "cost_parts": "",
        "cost_sublet": "",
        "costs": "",
        "create": {
          "jobinfo": "",
          "newowner": "",
          "newvehicle": "",
          "novehicle": "",
          "ownerinfo": "",
          "vehicleinfo": ""
        },
        "createiouwarning": "",
        "creating_new_job": "Création d'un nouvel emploi ...",
        "deductible": {
          "stands": "",
          "waived": ""
        },
        "deleteconfirm": "",
        "deletedelivery": "",
        "deleteintake": "",
        "deletewatchers": "",
        "deliverchecklist": "",
        "difference": "",
        "diskscan": "",
        "dms": {
          "apexported": "",
          "damageto": "",
          "defaultstory": "",
          "disablebillwip": "",
          "earlyro": {
            "created": "",
            "fields": "",
            "willupdate": ""
          },
          "invoicedatefuture": "",
          "kmoutnotgreaterthankmin": "",
          "logs": "",
          "notallocated": "",
          "postingform": "",
          "totalallocated": ""
        },
        "documents": "Les documents",
        "documents-images": "",
        "documents-other": "",
        "duplicateconfirm": "",
        "emailaudit": "",
        "employeeassignments": "",
        "esignature_imex": "",
        "esignature_rome": "",
        "estimatelines": "",
        "estimator": "",
        "existing_jobs": "Emplois existants",
        "federal_tax_amt": "",
        "gpdollars": "",
        "gppercent": "",
        "hrs_claimed": "",
        "hrs_total": "",
        "importnote": "",
        "inproduction": "",
        "intakechecklist": "",
        "iou": "",
        "job": "",
        "jobcosting": "",
        "jobtotals": "",
        "labor_hrs": "",
        "labor_rates_subtotal": "",
        "laborallocations": "",
        "labortotals": "",
        "lines": "Estimer les lignes",
        "local_tax_amt": "",
        "mapa": "",
        "markforreexport": "",
        "mash": "",
        "masterbypass": "",
        "materials": {
          "mapa": ""
        },
        "missingprofileinfo": "",
        "multipayers": "",
        "net_repairs": "",
        "notes": "Remarques",
        "othertotal": "",
        "outstanding_ar": "",
        "outstanding_credit_memos": "",
        "outstanding_ppd": "",
        "outstanding_reconciliation_discrep": "",
        "outstanding_sublets": "",
        "outstandinghours": "",
        "override_header": "Remplacer l'en-tête d'estimation à l'importation?",
        "ownerassociation": "",
        "parts": "les pièces",
        "parts_lines": "",
        "parts_received": "",
        "parts_tax_rates": "",
        "partsfilter": "",
        "partssubletstotal": "",
        "partstotal": "",
        "performance": "",
        "pimraryamountpayable": "",
        "plitooltips": {
          "billtotal": "",
          "calculatedcreditsnotreceived": "",
          "creditmemos": "",
          "creditsnotreceived": "",
          "discrep1": "",
          "discrep2": "",
          "discrep3": "",
          "laboradj": "",
          "partstotal": "",
          "totalreturns": ""
        },
        "ppc": "",
        "ppdnotexported": "",
        "profileadjustments": "",
        "profitbypassrequired": "",
        "profits": "",
        "prt_dsmk_total": "",
        "rates": "Les taux",
        "rates_subtotal": "",
        "reconciliation": {
          "billlinestotal": "",
          "byassoc": "",
          "byprice": "",
          "clear": "",
          "discrepancy": "",
          "joblinestotal": "",
          "multipleactprices": "",
          "multiplebilllines": "",
          "multiplebillsforactprice": "",
          "removedpartsstrikethrough": ""
        },
        "reconciliationheader": "",
        "relatedros": "",
        "remove_from_ar": "",
        "returntotals": "",
        "ro_guard": {
          "enforce_ar": "",
          "enforce_bills": "",
          "enforce_cm": "",
          "enforce_labor": "",
          "enforce_ppd": "",
          "enforce_profit": "",
          "enforce_sublet": "",
          "enforce_validation": "",
          "enforced": ""
        },
        "roguard": "",
        "roguardwarnings": "",
        "rosaletotal": "",
        "sale_additional": "",
        "sale_labor": "",
        "sale_parts": "",
        "sale_sublet": "",
        "sales": "",
        "savebeforeconversion": "",
        "scheduledinchange": "",
        "sent": "",
        "specialcoveragepolicy": "",
        "state_tax_amt": "",
        "subletsnotcompleted": "",
        "subletstotal": "",
        "subtotal": "",
        "supplementnote": "",
        "suspended": "",
        "suspense": "",
        "tasks": "",
        "threshhold": "",
        "total_cost": "",
        "total_cust_payable": "",
        "total_cust_payable_cash_discount": "",
        "total_repairs": "",
        "total_repairs_cash_discount": "",
        "total_sales": "",
        "total_sales_tax": "",
        "totals": "",
        "unvoidnote": "",
        "update_scheduled_completion": "",
        "vehicle_info": "Véhicule",
        "vehicleassociation": "",
        "viewallocations": "",
        "voidjob": "",
        "voidnote": ""
      },
      "successes": {
        "addedtoproduction": "",
        "all_deleted": "{{count}} travaux supprimés avec succès.",
        "closed": "",
        "converted": "Travail converti avec succès.",
        "created": "Le travail a été créé avec succès. Clique pour voir.",
        "creatednoclick": "",
        "delete": "",
        "deleted": "Le travail a bien été supprimé.",
        "duplicated": "",
        "early_ro_created": "",
        "exported": "",
        "invoiced": "",
        "ioucreated": "",
        "partsqueue": "",
        "partsqueue_removed": "Le travail a été retiré de la file d'attente des pièces.",
        "save": "Le travail a été enregistré avec succès.",
        "savetitle": "Enregistrement enregistré avec succès.",
        "supplemented": "Travail complété avec succès.",
        "updated": "",
        "voided": ""
      }
    },
    "jobtimeline": {
      "categories": {
        "activity": "Activité",
        "documents": "Documents",
        "emails": "Courriels",
        "esign": "Signatures électroniques",
        "messages": "Messages",
        "notes": "Notes",
        "parts": "Pièces",
        "payments": "Paiements",
        "status": "Statut"
      },
      "empty": "Aucun événement pour ce dossier pour le moment.",
      "events": {
        "bill": "Facture {{invoice_number}} reçue de {{vendor}}",
        "document": "Document ajouté : {{name}}",
        "email": "Courriel envoyé : {{subject}}",
        "esign_completed": "Signature électronique complétée : {{title}}",
        "esign_sent": "Signature électronique demandée : {{title}}",
        "message_image": "(Pièce jointe image)",
        "message_received": "Message texte reçu",
        "message_sent": "Message texte envoyé",
        "message_system": "Message système",
        "parts_dispatch": "Distribution de pièces no {{number}} ({{count}} lignes)",
        "parts_order": "Commande de pièces no {{order_number}} passée chez {{vendor}} ({{count}} lignes)",
        "parts_return": "Retour de pièces no {{order_number}} à {{vendor}} ({{count}} lignes)",
        "parts_sublet": "",
        "payment": "Paiement reçu ({{type}}) de {{payer}}",
        "quote_suffix": ""
      },
      "filetypes": {
        "document": "Document",
        "image": "Image",
        "pdf": "PDF",
        "video": "Vidéo"
      },
      "open": "Ouvrir",
      "showmore": "Afficher {{count}} de plus",
      "tab": "Chronologie",
      "updated": "Mis à jour"
    },
    "landing": {
      "bigfeature": {
        "subtitle": "",
        "title": ""
      },
      "footer": {
        "company": {
          "about": "",
          "contact": "",
          "disclaimers": "",
          "name": "",
          "privacypolicy": ""
        },
        "io": {
          "help": "",
          "name": "",
          "status": ""
        },
        "slogan": ""
      },
      "hero": {
        "button": "",
        "title": ""
      },
      "labels": {
        "features": "",
        "managemyshop": "",
        "pricing": ""
      },
      "pricing": {
        "basic": {
          "name": "",
          "sub": ""
        },
        "essentials": {
          "name": "",
          "sub": ""
        },
        "pricingtitle": "",
        "pro": {
          "name": "",
          "sub": ""
        },
        "title": "",
        "unlimited": {
          "name": "",
          "sub": ""
        }
      }
    },
    "menus": {
      "currentuser": {
        "languageselector": "La langue",
        "profile": "Profil"
      },
      "header": {
        "accounting": "",
        "accounting-payables": "",
        "accounting-payments": "",
        "accounting-receivables": "",
        "activejobs": "Emplois actifs",
        "all_tasks": "",
        "alljobs": "",
        "allpayments": "",
        "availablejobs": "Emplois disponibles",
        "bills": "",
        "courtesycars": "",
        "courtesycars-all": "",
        "courtesycars-contracts": "",
        "courtesycars-newcontract": "",
        "create_task": "",
        "customers": "Les clients",
        "dashboard": "",
        "enterbills": "",
        "entercardpayment": "",
        "enterpayment": "",
        "entertimeticket": "",
        "export": "",
        "export-logs": "",
        "help": "",
        "home": "Accueil",
        "inventory": "",
        "jobs": "Emplois",
        "my_tasks": "",
        "newjob": "",
        "owners": "Propriétaires",
        "parts-queue": "",
        "phonebook": "",
        "productionboard": "",
        "productionlist": "",
        "readyjobs": "",
        "recent": "",
        "remoteassist": "",
        "reportcenter": "",
        "rescueme": "",
        "rescuemezoho": "",
        "schedule": "Programme",
        "scoreboard": "",
        "search": {
          "bills": "",
          "jobs": "",
          "owners": "",
          "payments": "",
          "phonebook": "",
          "vehicles": ""
        },
        "shiftclock": "",
        "shop": "Mon magasin",
        "shop_config": "Configuration",
        "shop_csi": "",
        "shop_templates": "",
        "shop_vendors": "Vendeurs",
        "tasks": "",
        "temporarydocs": "",
        "timetickets": "",
        "ttapprovals": "",
        "vehicles": "Véhicules"
      },
      "jobsactions": {
        "admin": "",
        "cancelallappointments": "",
        "closejob": "",
        "deletejob": "",
        "duplicate": "",
        "duplicatenolines": "",
        "newcccontract": "",
        "sections": {
          "appointments": "Appointments",
          "billing": "Billing",
          "checklists": "Checklists & Delivery",
          "communication": "Customer & Communication",
          "job_tools": "Job Tools",
          "production": "Production",
          "time_tasks": "Time & Tasks"
        },
        "submit-for-testing": "",
        "void": ""
      },
      "jobsdetail": {
        "claimdetail": "Détails de la réclamation",
        "dates": "Rendez-vous",
        "financials": "",
        "general": "",
        "insurance": "",
        "labor": "La main d'oeuvre",
        "lifecycle": "",
        "parts": "",
        "partssublet": "Pièces / Sous-location",
        "rates": "",
        "repairdata": "Données de réparation",
        "totals": ""
      },
      "profilesidebar": {
        "profile": "Mon profil",
        "shops": "Mes boutiques"
      },
      "tech": {
        "assignedjobs": "",
        "claimtask": "",
        "dispatchedparts": "",
        "home": "",
        "jobclockin": "",
        "jobclockout": "",
        "joblookup": "",
        "login": "",
        "logout": "",
        "productionboard": "",
        "productionlist": "",
        "shiftclockin": ""
      }
    },
    "messaging": {
      "actions": {
        "back_to_conversations": "Retour aux conversations",
        "link": "",
        "new": "",
        "openchat": "",
        "preview_media": "Aperçu de l’image en taille réelle"
      },
      "errors": {
        "download_image": "Erreur lors du téléchargement de l’image. {{message}}",
        "invalidphone": "",
        "no_consent": "",
        "noattachedjobs": "",
        "save_image": "Erreur lors de l'enregistrement de l'image dans le dossier. {{message}}",
        "updatinglabel": ""
      },
      "labels": {
        "active": "Actives",
        "addlabel": "Ajouter une étiquette à cette conversation.",
        "archive": "Archiver",
        "archived": "Archivées",
        "archived_read_only": "Cette conversation est archivée et en lecture seule.",
        "conversation_list_mode": "Vue de la liste des conversations",
        "earlier": "Plus tôt",
        "edit_label": "Modifier l’étiquette",
        "live": "En direct",
        "mark_unread": "Marquer comme non lu",
        "more_jobs": "+{{count}} de plus",
        "maxtenimages": "Vous pouvez sélectionner un maximum de 10 images à la fois.",
        "messaging": "Messagerie",
        "no_consent": "Désabonné",
        "no_job_media": "Aucun média trouvé pour ce travail.",
        "no_media_for_tag": "Aucun média ne correspond à cette étiquette.",
        "noallowtxt": "Ce client n’a pas indiqué qu’il autorise l’envoi de messages.",
        "nojobs": "Aucun travail associé.",
        "not_converted_abbreviation": "N/A",
        "nopush": "Mode d’interrogation activé",
        "phonenumber": "Nº de téléphone",
        "presets": "Réponses rapides",
        "page_down": "Page suivante",
        "page_up": "Page précédente",
        "recentonly": "Seules les 50 conversations les plus récentes sont affichées. Pour trouver une conversation antérieure, ouvrez le contact associé et sélectionnez son numéro de téléphone.",
        "ro_chip": "RO {{number}}",
        "save_to_job": "Enregistrer dans les documents du travail",
        "scroll_bottom": "Aller en bas",
        "scroll_top": "Aller en haut",
        "search_conversations": "Rechercher par nom, téléphone, étiquette ou RO",
        "select_conversation": "Sélectionnez une conversation pour afficher les messages.",
        "select_job": "Sélectionner un travail",
        "empty_conversation": "Envoyez un message pour démarrer la conversation.",
        "selectmedia": "Sélectionner un média",
        "send_hint_newline": "pour une nouvelle ligne",
        "send_hint_send": "pour envoyer",
        "sentby": "Envoyé par {{by}} à {{time}}",
        "sms_segments": "{{used}} / {{max}} · {{count}} segment(s) SMS",
        "this_week": "Cette semaine",
        "team_member": "Membre de l’équipe",
        "today": "Aujourd’hui",
        "typeamessage": "Envoyer un message...",
        "unarchive": "Désarchiver",
        "unarchive_to_continue": "Désarchivez cette conversation pour envoyer un autre message.",
        "unread_messages": "Messages non lus : {{count}}",
        "unlink_job": "Dissocier le travail"
      },
      "presence": {
        "typing": "{{name}} écrit…",
        "typing_another_window": "Vous écrivez dans une autre fenêtre",
        "typing_many": "{{name}} et {{count}} autres personnes écrivent…",
        "viewing": "{{name}} consulte cette conversation",
        "viewing_many": "{{name}} et {{count}} autres personnes consultent cette conversation"
      },
      "relative": {
        "days": "{{count}} j",
        "hours": "{{count}} h",
        "minutes": "{{count}} min",
        "months": "{{count}} mois",
        "now": "maintenant",
        "years": "{{count}} an"
      },
      "render": {
        "conversation_list": ""
      }
    },
    "notes": {
      "actions": {
        "actions": "actes",
        "deletenote": "Supprimer la note",
        "edit": "Note éditée",
        "new": "Nouvelle note",
        "savetojobnotes": ""
      },
      "errors": {
        "inserting": ""
      },
      "fields": {
        "createdby": "Créé par",
        "critical": "Critique",
        "pinned": "",
        "private": "privé",
        "text": "Contenu",
        "type": "",
        "types": {
          "customer": "",
          "general": "",
          "office": "",
          "paint": "",
          "parts": "",
          "shop": "",
          "supplement": "",
          "estimator": ""
        },
        "updatedat": "Mis à jour à"
      },
      "labels": {
        "addtorelatedro": "",
        "newnoteplaceholder": "Ajouter une note...",
        "notetoadd": "",
        "pinned_note": "",
        "systemnotes": "",
        "usernotes": ""
      },
      "successes": {
        "create": "Remarque créée avec succès.",
        "deleted": "Remarque supprimée avec succès.",
        "updated": "Remarque mise à jour avec succès."
      }
    },
    "notifications": {
      "actions": {
        "remove": ""
      },
      "aria": {
        "toggle": ""
      },
      "channels": {
        "app": "",
        "email": "",
        "fcm": ""
      },
      "labels": {
        "add-watchers": "",
        "add-watchers-team": "",
        "auto-add": "",
        "auto-add-description": "",
        "auto-add-failure": "",
        "auto-add-off": "",
        "auto-add-on": "",
        "auto-add-success": "",
        "employee-notification": "",
        "employee-search": "",
        "mark-all-read": "",
        "new-notification-title": "",
        "no-watchers": "",
        "notification-center": "",
        "notification-popup-title": "",
        "notification-settings-failure": "",
        "notification-settings-success": "",
        "notificationscenarios": "",
        "ro-number": "",
        "save": "",
        "scenario": "",
        "show-unread-only": "",
        "teams-search": "",
        "unwatch": "",
        "watch": "",
        "watching-issue": ""
      },
      "scenarios": {
        "alternate-transport-changed": "",
        "bill-posted": "",
        "critical-parts-status-changed": "",
        "esign-document-completed": "E-Sign Document Completed",
        "esign-document-opened": "E-Sign Document Opened",
        "esign-document-upload-failed": "E-Sign Document Upload Failed",
        "intake-delivery-checklist-completed": "",
        "job-added-to-production": "",
        "job-assigned-to-me": "",
        "job-status-change": "",
        "new-media-added-reassigned": "",
        "new-note-added": "",
        "new-time-ticket-posted": "",
        "part-marked-back-ordered": "",
        "payment-collected-completed": "",
        "schedule-dates-changed": "",
        "supplement-imported": "",
        "tasks-updated-created": ""
      },
      "tooltips": {
        "job-watchers": "",
        "not-employee": "",
        "not-employee-notifications": ""
      }
    },
    "owner": {
      "labels": {
        "noownerinfo": ""
      }
    },
    "owners": {
      "actions": {
        "update": ""
      },
      "errors": {
        "deleting": "",
        "noaccess": "L'enregistrement n'existe pas ou vous n'y avez pas accès.",
        "saving": "",
        "selectexistingornew": ""
      },
      "fields": {
        "accountingid": "",
        "address": "Adresse",
        "name": "Prénom",
        "note": "",
        "ownr_addr1": "Adresse",
        "ownr_addr2": "Adresse 2 ",
        "ownr_city": "Ville",
        "ownr_co_nm": "",
        "ownr_ctry": "Pays",
        "ownr_ea": "Email",
        "ownr_fn": "Prénom",
        "ownr_ln": "Nom de famille",
        "ownr_ph1": "Téléphone 1",
        "ownr_ph2": "",
        "ownr_st": "Etat / Province",
        "ownr_title": "Titre",
        "ownr_zip": "Zip / code postal",
        "preferred_contact": "Méthode de contact préférée",
        "tax_number": ""
      },
      "forms": {
        "address": "",
        "contact": "",
        "name": ""
      },
      "labels": {
        "cell": "",
        "create_new": "Créez un nouvel enregistrement de propriétaire.",
        "deleteconfirm": "",
        "email": "",
        "existing_owners": "Propriétaires existants",
        "fromclaim": "",
        "fromowner": "",
        "home": "",
        "other": "",
        "phone": "",
        "relatedjobs": "",
        "sms": "",
        "updateowner": "",
        "work": ""
      },
      "successes": {
        "delete": "",
        "save": "Le propriétaire a bien enregistré."
      }
    },
    "parts": {
      "actions": {
        "order": "Commander des pièces",
        "orderinhouse": ""
      },
      "labels": {
        "view_counts_only": "",
        "view_timestamps": ""
      }
    },
    "parts_dispatch": {
      "actions": {
        "accept": ""
      },
      "errors": {
        "accepting": "",
        "creating": ""
      },
      "fields": {
        "number": "",
        "percent_accepted": ""
      },
      "labels": {
        "notyetdispatched": "",
        "parts_dispatch": ""
      }
    },
    "parts_dispatch_lines": {
      "fields": {
        "accepted_at": ""
      }
    },
    "parts_orders": {
      "actions": {
        "backordered": "",
        "create_return": "",
        "place_order": "",
        "receive": "",
        "receivebill": "",
        "save_quote": ""
      },
      "errors": {
        "associatedbills": "",
        "backordering": "",
        "creating": "Erreur rencontrée lors de la création de la commande de pièces.",
        "oec": "",
        "saving": "",
        "updating": ""
      },
      "fields": {
        "act_price": "",
        "backordered_eta": "",
        "backordered_on": "",
        "cm_received": "",
        "comments": "",
        "cost": "",
        "db_price": "",
        "deliver_by": "",
        "job_line_id": "",
        "line_desc": "",
        "line_remarks": "",
        "lineremarks": "Remarques sur la ligne",
        "oem_partno": "",
        "order_date": "",
        "order_number": "",
        "orderedby": "",
        "part_type": "",
        "quantity": "",
        "return": "",
        "returned_on": "Retourné le",
        "returnedby": "Retourné par",
        "status": ""
      },
      "labels": {
        "all": "Tous",
        "allpartsto": "",
        "awaitingcm": "En attente de note de crédit",
        "backordered": "En rupture",
        "cmreceivedstate": "Note de crédit reçue",
        "cmreceivedsummary": "{{received}} sur {{total}} notes de crédit reçues",
        "confirmdelete": "",
        "cost_from_vendor_discount": "",
        "creditingbill": "Facture créditée",
        "customdiscount": "Remise personnalisée",
        "custompercent": "",
        "email": "Envoyé par email",
        "inthisorder": "Pièces dans cette commande",
        "inthisreturn": "Pièces dans ce retour",
        "is_quote": "",
        "is_quote_help": "",
        "mark_as_received": "",
        "newpartsorder": "",
        "notyetordered": "",
        "oec": "",
        "onthisreturn": "Pièces sur ce retour",
        "order_type": "",
        "orderhistory": "Historique des commandes",
        "overdue": "En retard",
        "overduecount": "{{count}} ligne(s) en retard",
        "parts_order": "",
        "parts_orders": "",
        "parts_returns": "",
        "price_discount_applied": "{{percent}}% de rabais",
        "print": "Afficher le formulaire imprimé",
        "quickdiscount": "Remise rapide",
        "quote": "",
        "quote_banner": "",
        "receive": "",
        "removefrompartsqueue": "",
        "removefrompartsqueue_help": "",
        "returnpartsorder": "",
        "sublet_order": "",
        "summary_cost": "",
        "summary_lines": "",
        "vendorcontact": "Contact du fournisseur"
      },
      "sections": {
        "options": "",
        "order": "",
        "output": "",
        "return": "Détails du retour"
      },
      "successes": {
        "created": "Commande de pièces créée avec succès.",
        "line_updated": "",
        "received": "",
        "return_created": ""
      },
      "validations": {
        "atleastoneline": ""
      }
    },
    "payments": {
      "actions": {
        "generatepaymentlink": ""
      },
      "errors": {
        "exporting": "",
        "exporting-partner": "",
        "inserting": ""
      },
      "fields": {
        "amount": "",
        "created_at": "",
        "date": "",
        "exportedat": "",
        "memo": "",
        "payer": "",
        "paymentnum": "",
        "stripeid": "",
        "transactionid": "",
        "type": ""
      },
      "labels": {
        "balance": "",
        "ca_bc_etf_table": "",
        "customer": "",
        "edit": "",
        "electronicpayment": "",
        "external": "",
        "findermodal": "",
        "insurance": "",
        "markexported": "",
        "markforreexport": "",
        "new": "",
        "signup": "",
        "smspaymentreminder": "",
        "title": "",
        "totalpayments": ""
      },
      "successes": {
        "exported": "",
        "markexported": "",
        "markreexported": "",
        "payment": "",
        "paymentupdate": "",
        "stripe": ""
      }
    },
    "phonebook": {
      "actions": {
        "new": "New Phonebook Entry"
      },
      "errors": {
        "adding": "",
        "saving": ""
      },
      "fields": {
        "address1": "",
        "address2": "",
        "category": "",
        "city": "",
        "company": "",
        "country": "",
        "email": "",
        "fax": "",
        "firstname": "",
        "lastname": "",
        "phone1": "",
        "phone2": "",
        "state": ""
      },
      "labels": {
        "entry": "Phonebook Entry",
        "noneselected": "",
        "onenamerequired": "",
        "sections": {
          "address": "Address",
          "communication": "Communication",
          "identity": "Identity",
          "location": "Location"
        },
        "vendorcategory": ""
      },
      "successes": {
        "added": "",
        "deleted": "",
        "saved": ""
      }
    },
    "printcenter": {
      "appointments": {
        "appointment_confirmation": ""
      },
      "banners": {
        "esignature_promo": "Vous en avez assez des signatures papier? Essayez {{app}} dès aujourd'hui.",
        "esignature_signup_link": "S'inscrire",
        "esignature_signup_tooltip": "Avant l'inscription, confirmez que la personne qui remplit l'accord est autorisée à signer pour l'entreprise et à approuver l'accord mensuel à partir du prochain cycle de facturation. Les prix et modalités en vigueur sont indiqués dans le formulaire."
      },
      "bills": {
        "inhouse_invoice": ""
      },
      "courtesycarcontract": {
        "courtesy_car_contract": "",
        "courtesy_car_impound": "",
        "courtesy_car_inventory": "",
        "courtesy_car_terms": ""
      },
      "errors": {
        "nocontexttype": ""
      },
      "jobs": {
        "3rdpartyfields": {
          "addr1": "",
          "addr2": "",
          "addr3": "",
          "address": "Address",
          "amounts": "Amounts",
          "attn": "",
          "city": "",
          "custgst": "",
          "ded_amt": "",
          "delivery": "Delivery",
          "depreciation": "",
          "location": "Location",
          "other": "",
          "payer": "Choose Payer",
          "payeralert": "Choose either a vendor or an insurance company. Selecting one will disable the other.",
          "payerhint": "Select the third-party payer first, then confirm or adjust the address and invoice amounts.",
          "payerrequired": "Select a vendor or an insurance company.",
          "ponumber": "",
          "reference": "Reference",
          "refnumber": "",
          "selectinsurance": "Select an insurance company",
          "selectvendor": "Select a vendor",
          "sendtype": "",
          "state": "",
          "zip": ""
        },
        "3rdpartypayer": "",
        "ab_proof_of_loss": "",
        "appointment_confirmation": "",
        "appointment_reminder": "",
        "casl_authorization": "",
        "committed_timetickets_ro": "",
        "coversheet_landscape": "",
        "coversheet_portrait": "",
        "csi_invitation": "",
        "csi_invitation_action": "",
        "diagnostic_authorization": "",
        "dms_posting_sheet": "",
        "envelope_return_address": "",
        "estimate": "",
        "estimate_detail": "",
        "estimate_followup": "",
        "express_repair_checklist": "",
        "filing_coversheet_landscape": "",
        "filing_coversheet_portrait": "",
        "final_invoice": "",
        "fippa_authorization": "",
        "folder_label_multiple": "",
        "glass_express_checklist": "",
        "guarantee": "",
        "individual_job_note": "",
        "invoice_customer_payable": "",
        "invoice_total_payable": "",
        "iou_form": "",
        "job_costing_ro": "",
        "job_lifecycle_ro": "",
        "job_notes": "",
        "job_tasks": "",
        "key_tag": "",
        "labels": {
          "count": "",
          "labels": "",
          "position": ""
        },
        "lag_time_ro": "",
        "mechanical_authorization": "",
        "mpi_animal_checklist": "",
        "mpi_eglass_auth": "",
        "mpi_final_acct_sheet": "",
        "mpi_final_repair_acct_sheet": "",
        "paint_grid": "",
        "parts_dispatch": "",
        "parts_invoice_label_single": "",
        "parts_label_multiple": "",
        "parts_label_single": "",
        "parts_list": "",
        "parts_order": "",
        "parts_order_confirmation": "",
        "parts_order_history": "",
        "parts_return_slip": "",
        "payment_receipt": "",
        "payment_request": "",
        "payments_by_job": "",
        "purchases_by_ro_detail": "",
        "purchases_by_ro_summary": "",
        "qc_sheet": "",
        "rental_reservation": "",
        "ro_totals": "",
        "ro_with_description": "",
        "sgi_certificate_of_repairs": "",
        "sgi_windshield_auth": "",
        "stolen_recovery_checklist": "",
        "sublet_order": "",
        "supplement_request": "",
        "thank_you_ro": "",
        "thirdpartypayer": "",
        "timetickets_ro": "",
        "vehicle_check_in": "",
        "vehicle_delivery_check": "",
        "window_tag": "",
        "window_tag_sublet": "",
        "work_authorization": "",
        "worksheet_by_line_number": "",
        "worksheet_sorted_by_operation": "",
        "worksheet_sorted_by_operation_no_hours": "",
        "worksheet_sorted_by_operation_part_type": "",
        "worksheet_sorted_by_operation_type": "",
        "worksheet_sorted_by_team": ""
      },
      "labels": {
        "groups": {
          "authorization": "",
          "financial": "",
          "post": "",
          "pre": "",
          "ro": "",
          "worksheet": ""
        },
        "misc": "",
        "repairorder": "",
        "reportcentermodal": "",
        "speedprint": "",
        "title": ""
      },
      "payments": {
        "ca_bc_etf_table": "",
        "exported_payroll": ""
      },
      "special": {
        "attendance_detail_csv": ""
      },
      "subjects": {
        "jobs": {
          "individual_job_note": "",
          "parts_dispatch": "",
          "parts_order": "",
          "parts_return_slip": "",
          "sublet_order": ""
        }
      },
      "vendors": {
        "purchases_by_vendor_detailed": "",
        "purchases_by_vendor_summary": ""
      }
    },
    "production": {
      "actions": {
        "addcolumns": "",
        "bodypriority-clear": "",
        "bodypriority-set": "",
        "detailpriority-clear": "",
        "detailpriority-set": "",
        "paintpriority-clear": "",
        "paintpriority-set": "",
        "remove": "",
        "removecolumn": "",
        "saveconfig": "",
        "saveprofile": "Enregistrer le profil",
        "suspend": "",
        "unsuspend": ""
      },
      "constants": {
        "main_profile": ""
      },
      "errors": {
        "boardupdate": "",
        "name_exists": "",
        "name_required": "",
        "removing": "",
        "settings": ""
      },
      "labels": {
        "actual_in": "",
        "addnewprofile": "",
        "alert": "",
        "alertoff": "",
        "alerton": "",
        "alerts": "",
        "ats": "",
        "bodyhours": "",
        "bodypriority": "",
        "bodyshop": {
          "labels": {
            "qbo_departmentid": "",
            "qbo_usa": ""
          }
        },
        "boardprofiles": "Board Profiles",
        "card_size": "",
        "cardcolor": "",
        "cardsettings": "",
        "click_for_statuses": "",
        "clm_no": "",
        "color_by": "Color By",
        "comment": "",
        "compact": "",
        "detailpriority": "",
        "employeeassignments": "",
        "employeesearch": "",
        "estimator": "",
        "horizontal": "",
        "ins_co_nm": "",
        "jobdetail": "",
        "kiosk_mode": "",
        "laborhrs": "",
        "legend": "",
        "model_info": "",
        "note": "",
        "off": "",
        "on": "",
        "orientation": "",
        "ownr_nm": "",
        "paintpriority": "",
        "partsreceived": "",
        "partsstatus": "",
        "production_note": "",
        "refinishhours": "",
        "scheduled_completion": "",
        "selectview": "",
        "stickyheader": "",
        "sublets": "",
        "subtotal": "",
        "tall": "",
        "tasks": "",
        "totalhours": "",
        "touchtime": "",
        "unassigned": "",
        "vertical": "",
        "viewname": "",
        "wide": ""
      },
      "options": {
        "color_body": "Body Technician",
        "color_insurance": "Insurance Company",
        "color_none": "None",
        "color_prep": "Prep Technician",
        "color_refinish": "Refinish Technician",
        "color_severity": "Job Size / Severity",
        "color_writer": "Writer / CSR",
        "horizontal": "",
        "large": "",
        "medium": "",
        "small": "",
        "vertical": ""
      },
      "settings": {
        "board_settings": "",
        "filters": {
          "actual_in_range": "Actual In",
          "alt_transport": "Alternative Transportation",
          "any": "Any",
          "any_date": "Any Date",
          "custom_range": "Custom Range",
          "md_estimators": "",
          "md_ins_cos": "",
          "max": "Max",
          "min": "Min",
          "no_status": "No Status",
          "part_statuses": "Parts Statuses",
          "parts_received": "Parts Received",
          "parts_received_fully_received": "Fully Received",
          "parts_received_has_parts": "Has Parts",
          "parts_received_missing_received": "Missing Received Parts",
          "parts_received_no_parts": "No Parts",
          "parts_received_partially_received": "Partially Received",
          "production_note": "Production Note",
          "scheduled_completion_range": "Scheduled Completion",
          "sublets": "Sublets",
          "subtotal_range": "Subtotal",
          "tasks": "Tasks",
          "technicians": "Technicians / Employees",
          "this_month": "This Month",
          "this_quarter": "This Quarter",
          "this_week": "This Week",
          "this_year": "This Year",
          "vehicle_makes": "Vehicle Makes",
          "with": "With",
          "without": "Without",
          "writers": "Writers / CSRs"
        },
        "filters_title": "",
        "information": "",
        "layout": "",
        "statistics": {
          "exclude_suspended": "",
          "jobs_in_production": "Véhicules en production",
          "tasks_in_production": "",
          "tasks_in_view": "",
          "tasks_on_board": "",
          "total_amount_in_production": "",
          "total_amount_in_view": "",
          "total_amount_on_board": "",
          "total_hours_in_production": "",
          "total_hours_in_view": "",
          "total_hours_on_board": "",
          "total_jobs_in_view": "Véhicules dans la vue",
          "total_jobs_on_board": "Véhicules au tableau",
          "total_lab_in_production": "",
          "total_lab_in_view": "",
          "total_lab_on_board": "",
          "total_lar_in_production": "",
          "total_lar_in_view": "",
          "total_lar_on_board": ""
        },
        "statistics_title": ""
      },
      "statistics": {
        "currency_symbol": "",
        "hours": "",
        "jobs": "",
        "jobs_in_production": "Véhicules en production",
        "tasks": "",
        "tasks_in_production": "",
        "tasks_in_view": "",
        "tasks_on_board": "",
        "total_amount_in_production": "",
        "total_amount_in_view": "",
        "total_amount_on_board": "",
        "total_hours_in_production": "",
        "total_hours_in_view": "",
        "total_hours_on_board": "",
        "total_jobs_in_view": "Véhicules dans la vue",
        "total_jobs_on_board": "Véhicules au tableau",
        "total_lab_in_production": "",
        "total_lab_in_view": "",
        "total_lab_on_board": "",
        "total_lar_in_production": "",
        "total_lar_in_view": "",
        "total_lar_on_board": "",
        "vehicles": "Véhicules"
      },
      "successes": {
        "removed": ""
      }
    },
    "profile": {
      "errors": {
        "state": "Erreur lors de la lecture de l'état de la page.  Rafraichissez, s'il vous plait."
      },
      "labels": {
        "activeshop": ""
      },
      "successes": {
        "updated": ""
      }
    },
    "reportcenter": {
      "actions": {
        "generate": ""
      },
      "labels": {
        "advanced_filters": "",
        "advanced_filters_false": "",
        "advanced_filters_filter_field": "",
        "advanced_filters_filter_operator": "",
        "advanced_filters_filter_value": "",
        "advanced_filters_filters": "",
        "advanced_filters_hide": "",
        "advanced_filters_show": "",
        "advanced_filters_sorter_direction": "",
        "advanced_filters_sorter_field": "",
        "advanced_filters_sorters": "",
        "advanced_filters_true": "",
        "dates": "",
        "employee": "",
        "filterson": "",
        "generateasemail": "",
        "groups": {
          "customers": "",
          "jobs": "",
          "payroll": "",
          "purchases": "",
          "sales": ""
        },
        "key": "",
        "objects": {
          "appointments": "",
          "bills": "",
          "csi": "",
          "exportlogs": "",
          "jobs": "",
          "parts_orders": "",
          "payments": "",
          "scoreboard": "",
          "tasks": "",
          "timetickets": ""
        },
        "vendor": ""
      },
      "production_search": {
        "action_csr": "CSR",
        "action_technician": "Technicien",
        "action_writer": "Rédacteur",
        "hints": {
          "close": "fermer",
          "navigate": "naviguer",
          "select": "sélectionner"
        },
        "noresults": "Aucun résultat pour « {{search}} »",
        "placeholder": "Rechercher des rapports, employés, catégories, statuts...",
        "scope_all": "Tout",
        "scope_category": "Catégorie",
        "scope_employees": "Employés",
        "scope_reports": "Rapports",
        "scope_status": "Statut",
        "section_employees": "Employés",
        "section_reports": "Rapports"
      },
      "templates": {
        "adp_payroll_flat": "",
        "adp_payroll_straight": "",
        "anticipated_revenue": "",
        "ar_aging": "",
        "attendance_detail": "",
        "attendance_employee": "",
        "attendance_summary": "",
        "committed_timetickets": "",
        "committed_timetickets_employee": "",
        "committed_timetickets_summary": "",
        "credits_not_received_date": "",
        "credits_not_received_date_vendorid": "",
        "csi": "",
        "customer_list": "",
        "customer_list_excel": "",
        "cycle_time_analysis": "",
        "estimates_written_converted": "",
        "estimator_detail": "",
        "estimator_summary": "",
        "export_payables": "",
        "export_payments": "",
        "export_receivables": "",
        "exported_gsr_by_ro": "",
        "exported_gsr_by_ro_labor": "",
        "gsr_by_atp": "",
        "gsr_by_ats": "",
        "gsr_by_category": "",
        "gsr_by_csr": "",
        "gsr_by_delivery_date": "",
        "gsr_by_estimator": "",
        "gsr_by_exported_date": "",
        "gsr_by_ins_co": "",
        "gsr_by_make": "",
        "gsr_by_referral": "",
        "gsr_by_ro": "",
        "gsr_labor_only": "",
        "hours_sold_detail_closed": "",
        "hours_sold_detail_closed_csr": "",
        "hours_sold_detail_closed_estimator": "",
        "hours_sold_detail_closed_ins_co": "",
        "hours_sold_detail_closed_status": "",
        "hours_sold_detail_open": "",
        "hours_sold_detail_open_csr": "",
        "hours_sold_detail_open_estimator": "",
        "hours_sold_detail_open_ins_co": "",
        "hours_sold_detail_open_status": "",
        "hours_sold_summary_closed": "",
        "hours_sold_summary_closed_csr": "",
        "hours_sold_summary_closed_estimator": "",
        "hours_sold_summary_closed_ins_co": "",
        "hours_sold_summary_closed_status": "",
        "hours_sold_summary_open": "",
        "hours_sold_summary_open_csr": "",
        "hours_sold_summary_open_estimator": "",
        "hours_sold_summary_open_ins_co": "",
        "hours_sold_summary_open_status": "",
        "job_costing_ro_csr": "",
        "job_costing_ro_date_detail": "",
        "job_costing_ro_date_summary": "",
        "job_costing_ro_estimator": "",
        "job_costing_ro_ins_co": "",
        "job_lifecycle_date_detail": "",
        "job_lifecycle_date_summary": "",
        "jobs_completed_not_invoiced": "",
        "jobs_invoiced_not_exported": "",
        "jobs_reconcile": "",
        "jobs_scheduled_completion": "",
        "lag_time": "",
        "load_level": "",
        "lost_sales": "",
        "open_orders": "",
        "open_orders_csr": "",
        "open_orders_estimator": "",
        "open_orders_excel": "",
        "open_orders_ins_co": "",
        "open_orders_referral": "",
        "open_orders_specific_csr": "",
        "open_orders_status": "",
        "parts_backorder": "",
        "parts_not_recieved": "",
        "parts_not_recieved_vendor": "",
        "parts_received_not_scheduled": "",
        "payments_by_date": "",
        "payments_by_date_excel": "",
        "payments_by_date_payment": "",
        "payments_by_date_type": "",
        "production_by_category": "Production par catégorie",
        "production_by_category_one": "Production filtrée par catégorie",
        "production_by_csr": "Production par CSR",
        "production_by_csr_one": "Production filtrée par CSR",
        "production_by_writer": "Production par rédacteur",
        "production_by_writer_one": "Production filtrée par rédacteur",
        "production_by_last_name": "Production par nom de famille",
        "production_by_repair_status": "Production par statut",
        "production_by_repair_status_one": "Production filtrée par statut",
        "production_by_ro": "Production par OT",
        "production_by_target_date": "Production par date d'achèvement prévue",
        "production_by_technician": "Production par technicien",
        "production_by_technician_one": "Production filtrée par technicien",
        "production_not_production_status": "",
        "production_over_time": "",
        "psr_by_make": "",
        "purchase_return_ratio_excel": "",
        "purchase_return_ratio_grouped_by_vendor_detail": "",
        "purchase_return_ratio_grouped_by_vendor_summary": "",
        "purchases_by_cost_center_detail": "",
        "purchases_by_cost_center_summary": "",
        "purchases_by_date_excel": "",
        "purchases_by_date_range_detail": "",
        "purchases_by_date_range_summary": "",
        "purchases_by_ro_detail_date": "",
        "purchases_by_ro_summary_date": "",
        "purchases_by_vendor_detailed_date_range": "",
        "purchases_by_vendor_summary_date_range": "",
        "purchases_grouped_by_vendor_detailed": "",
        "purchases_grouped_by_vendor_summary": "",
        "returns_grouped_by_vendor_detailed": "",
        "returns_grouped_by_vendor_summary": "",
        "schedule": "",
        "scheduled_parts_list": "",
        "scoreboard_detail": "",
        "scoreboard_summary": "",
        "supplement_ratio_ins_co": "",
        "tasks_date": "",
        "tasks_date_employee": "",
        "thank_you_date": "",
        "timetickets": "",
        "timetickets_employee": "",
        "timetickets_summary": "",
        "total_loss_jobs": "",
        "unclaimed_hrs": "",
        "void_ros": "",
        "work_in_progress_committed_labour": "",
        "work_in_progress_jobs": "",
        "work_in_progress_labour": "",
        "work_in_progress_labour_summary": "",
        "work_in_progress_payables": "",
        "work_in_progress_payables_summary": ""
      }
    },
    "schedule": {
      "labels": {
        "atssummary": "",
        "employeevacation": "",
        "estimators": "",
        "ins_co_nm_filter": "",
        "intake": "",
        "manual": "",
        "manualevent": ""
      }
    },
    "scoreboard": {
      "actions": {
        "edit": ""
      },
      "errors": {
        "adding": "",
        "removing": "",
        "updating": ""
      },
      "fields": {
        "bodyhrs": "",
        "date": "",
        "painthrs": ""
      },
      "labels": {
        "allemployeetimetickets": "",
        "asoftodaytarget": "",
        "body": "",
        "bodyabbrev": "",
        "bodycharttitle": "",
        "calendarperiod": "",
        "combinedcharttitle": "",
        "dailyactual": "",
        "dailytarget": "",
        "efficiencyoverperiod": "",
        "entries": "",
        "jobs": "",
        "jobscompletednotinvoiced": "",
        "lastmonth": "",
        "lastweek": "",
        "monthlytarget": "",
        "priorweek": "",
        "productivestatistics": "",
        "productivetimeticketsoverdate": "",
        "refinish": "",
        "refinishabbrev": "",
        "refinishcharttitle": "",
        "targets": "",
        "thismonth": "",
        "thisweek": "",
        "timetickets": "",
        "timeticketsemployee": "",
        "todateactual": "",
        "total": "",
        "totalhrs": "",
        "totaloverperiod": "",
        "weeklyactual": "",
        "weeklytarget": "",
        "workingdays": ""
      },
      "successes": {
        "added": "",
        "removed": "",
        "updated": ""
      }
    },
    "settings": {
      "title": ""
    },
    "tasks": {
      "actions": {
        "edit": "",
        "new": "",
        "view": ""
      },
      "buttons": {
        "allTasks": "",
        "complete": "",
        "create": "",
        "delete": "",
        "edit": "",
        "myTasks": "",
        "refresh": ""
      },
      "date_presets": {
        "completion": "",
        "day": "",
        "days": "",
        "delivery": "",
        "next_week": "",
        "one_month": "",
        "three_months": "",
        "three_weeks": "",
        "today": "",
        "tomorrow": "",
        "two_weeks": ""
      },
      "errors": {
        "load_failure": ""
      },
      "failures": {
        "completed": "",
        "created": "",
        "deleted": "",
        "updated": ""
      },
      "fields": {
        "actions": "",
        "assigned_to": "",
        "bill": "",
        "billid": "",
        "completed": "",
        "created_at": "",
        "created_by": "",
        "description": "",
        "due_date": "",
        "job": {
          "ro_number": ""
        },
        "jobid": "",
        "jobline": "",
        "joblineid": "",
        "parts_order": "",
        "partsorderid": "",
        "priorities": {
          "high": "",
          "low": "",
          "medium": ""
        },
        "priority": "",
        "related_items": "",
        "remind_at": "",
        "title": ""
      },
      "labels": {
        "due_today": "",
        "go_to_job": "",
        "my_tasks_center": "",
        "no_due_date": "",
        "no_tasks": "",
        "overdue": "",
        "ro-number": "",
        "upcoming": ""
      },
      "placeholders": {
        "assigned_to": "",
        "billid": "",
        "description": "",
        "jobid": "",
        "joblineid": "",
        "partsorderid": ""
      },
      "successes": {
        "completed": "",
        "created": "",
        "deleted": "",
        "updated": ""
      },
      "titles": {
        "all_tasks": "",
        "completed": "",
        "deleted": "",
        "job_tasks": "",
        "mine": "",
        "my_tasks": ""
      },
      "validation": {
        "due_at_error_message": "",
        "remind_at_error_message": ""
      }
    },
    "tech": {
      "fields": {
        "employeeid": "",
        "pin": ""
      },
      "inactivity": {
        "logout_now": "Se déconnecter maintenant",
        "message": "Vous serez déconnecté dans {{seconds}} secondes en raison de votre inactivité.",
        "stay_signed_in": "Rester connecté",
        "title": "Êtes-vous toujours là?"
      },
      "labels": {
        "loggedin": "",
        "notloggedin": ""
      }
    },
    "templates": {
      "errors": {
        "updating": ""
      },
      "successes": {
        "updated": ""
      }
    },
    "timetickets": {
      "actions": {
        "claimtasks": "",
        "clockin": "",
        "clockout": "",
        "commit": "",
        "commitone": "",
        "enter": "",
        "payall": "",
        "printemployee": "",
        "uncommit": ""
      },
      "errors": {
        "clockingin": "",
        "clockingout": "",
        "creating": "",
        "deleting": "",
        "noemployeeforuser": "",
        "noemployeeforuser_sub": "",
        "notickets": "",
        "payall": "",
        "shiftalreadyclockedon": ""
      },
      "fields": {
        "actualhrs": "",
        "amount": "",
        "ciecacode": "",
        "clockhours": "",
        "clockoff": "",
        "clockon": "",
        "committed": "",
        "committed_at": "",
        "cost_center": "",
        "created_by": "",
        "date": "",
        "efficiency": "",
        "employee": "",
        "employee_team": "",
        "flat_rate": "",
        "memo": "",
        "not_committed": "",
        "pay": "",
        "payout_method": "",
        "productivehrs": "",
        "rate": "",
        "ro_number": "",
        "task_name": ""
      },
      "labels": {
        "alreadyclockedon": "",
        "ambreak": "",
        "amshift": "",
        "claimtaskpreview": "",
        "clockhours": "",
        "clockintojob": "",
        "deleteconfirm": "",
        "edit": "",
        "efficiency": "",
        "flat_rate": "",
        "jobhours": "",
        "lunch": "",
        "new": "",
        "payout_methods": {
          "commission": "",
          "hourly": ""
        },
        "payrollclaimedtasks": "",
        "pmbreak": "",
        "pmshift": "",
        "selectTicketDate": "",
        "shift": "",
        "shiftalreadyclockedon": "",
        "straight_time": "",
        "task": "",
        "timetickets": "",
        "unassigned": "",
        "zeroactualnegativeprod": ""
      },
      "successes": {
        "clockedin": "",
        "clockedout": "",
        "committed": "",
        "created": "",
        "deleted": "",
        "payall": ""
      },
      "validation": {
        "clockoffmustbeafterclockon": "",
        "clockoffwithoutclockon": "",
        "hoursenteredmorethanavailable": "",
        "unassignedlines": ""
      }
    },
    "titles": {
      "accounting-payables": "",
      "accounting-payments": "",
      "accounting-receivables": "",
      "all_tasks": "",
      "app": "",
      "bc": {
        "accounting-payables": "",
        "accounting-payments": "",
        "accounting-receivables": "",
        "all_tasks": "",
        "availablejobs": "",
        "bills-list": "",
        "contracts": "",
        "contracts-create": "",
        "contracts-detail": "",
        "courtesycars": "",
        "courtesycars-detail": "",
        "courtesycars-new": "",
        "dashboard": "",
        "dms": "",
        "export-logs": "",
        "feature-request": "",
        "inventory": "",
        "jobs": "",
        "jobs-active": "",
        "jobs-admin": "",
        "jobs-all": "",
        "jobs-checklist": "",
        "jobs-close": "",
        "jobs-deliver": "",
        "jobs-detail": "",
        "jobs-intake": "",
        "jobs-new": "",
        "jobs-ready": "",
        "my_tasks": "",
        "owner-detail": "",
        "owners": "",
        "parts": "",
        "parts-queue": "",
        "parts_settings": "",
        "payments-all": "",
        "phonebook": "",
        "productionboard": "",
        "productionlist": "",
        "profile": "",
        "schedule": "",
        "scoreboard": "",
        "shop": "",
        "shop-csi": "",
        "shop-templates": "",
        "shop-vendors": "",
        "simplified-parts-jobs": "",
        "tasks": "",
        "temporarydocs": "",
        "timetickets": "",
        "ttapprovals": "",
        "vehicle-details": "",
        "vehicles": ""
      },
      "bills-list": "",
      "contracts": "",
      "contracts-create": "",
      "contracts-detail": "",
      "courtesycars": "",
      "courtesycars-create": "",
      "courtesycars-detail": "",
      "dashboard": "",
      "dms": "",
      "export-logs": "",
      "feature-request": "",
      "imexonline": "",
      "inventory": "",
      "jobs": "Tous les emplois | {{app}}",
      "jobs-admin": "",
      "jobs-all": "",
      "jobs-checklist": "",
      "jobs-close": "",
      "jobs-create": "",
      "jobs-deliver": "",
      "jobs-intake": "",
      "jobsavailable": "Emplois disponibles | {{app}}",
      "jobsdetail": "Travail {{ro_number}} | {{app}}",
      "jobsdocuments": "Documents de travail {{ro_number}} | {{app}}",
      "manageroot": "Accueil | {{app}}",
      "my_tasks": "",
      "owners": "Tous les propriétaires | {{app}}",
      "owners-detail": "",
      "parts": "",
      "parts-queue": "",
      "parts_settings": "",
      "payments-all": "",
      "phonebook": "",
      "productionboard": "",
      "productionlist": "",
      "profile": "Mon profil | {{app}}",
      "readyjobs": "",
      "resetpassword": "",
      "resetpasswordvalidate": "",
      "romeonline": "",
      "schedule": "Horaire | {{app}}",
      "scoreboard": "",
      "shop": "Mon magasin | {{app}}",
      "shop-csi": "",
      "shop-templates": "",
      "shop_vendors": "Vendeurs | {{app}}",
      "simplified-parts-jobs": "",
      "tasks": "",
      "techconsole": "{{app}}",
      "techjobclock": "{{app}}",
      "techjoblookup": "{{app}}",
      "techshiftclock": "{{app}}",
      "temporarydocs": "",
      "timetickets": "",
      "ttapprovals": "",
      "vehicledetail": "Détails du véhicule {{vehicle} | {{app}}",
      "vehicles": "Tous les véhicules | {{app}}"
    },
    "trello": {
      "labels": {
        "add_card": "",
        "add_lane": "",
        "cancel": "",
        "delete_lane": "",
        "description": "",
        "label": "",
        "lane_actions": "",
        "title": ""
      }
    },
    "tt_approvals": {
      "actions": {
        "approveselected": ""
      },
      "labels": {
        "approval_queue_in_use": "",
        "calculate": ""
      }
    },
    "upsell": {
      "cta": {
        "learnmore": ""
      },
      "messages": {
        "accounting": {
          "payables": {
            "subtitle": "",
            "title": ""
          },
          "payments": {
            "subtitle": "",
            "title": ""
          },
          "receivables": {
            "subtitle": "",
            "title": ""
          }
        },
        "audit": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "bills": {
          "autoreconcile": {
            "subtitle": "",
            "title": ""
          },
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "checklist": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "courtesycars": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "csi": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "dashboard": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "lifecycle": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "media": {
          "general": {
            "subtitle": "",
            "title": ""
          },
          "mobile": {
            "subtitle": "",
            "title": ""
          }
        },
        "payments": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "scoreboard": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "smartscheduling": {
          "datepicker": {
            "subtitle": "",
            "title": ""
          },
          "general": {
            "subtitle": "",
            "title": ""
          },
          "hrsdelta": {
            "subtitle": "",
            "title": ""
          }
        },
        "techconsole": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "timetickets": {
          "allocations": {
            "subtitle": "",
            "title": ""
          },
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "visualboard": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        }
      }
    },
    "user": {
      "actions": {
        "changepassword": "",
        "dark_theme": "",
        "light_theme": "",
        "signout": "Déconnexion",
        "updateprofile": "Mettre à jour le profil"
      },
      "errors": {
        "updating": ""
      },
      "fields": {
        "authlevel": "",
        "displayname": "Afficher un nom",
        "email": "",
        "photourl": "URL de l'avatar"
      },
      "labels": {
        "actions": "",
        "changepassword": "",
        "notification_sound_disabled": "",
        "notification_sound_enabled": "",
        "notification_sound_help": "",
        "notification_sound_off": "",
        "notification_sound_on": "",
        "play_sound_for_new_messages": "",
        "profileinfo": "",
        "user_settings": ""
      },
      "successess": {
        "passwordchanged": ""
      }
    },
    "users": {
      "errors": {
        "signinerror": {
          "auth/invalid-email": "",
          "auth/user-disabled": "",
          "auth/user-not-found": "",
          "auth/wrong-password": ""
        }
      }
    },
    "vehicles": {
      "errors": {
        "deleting": "",
        "noaccess": "Le véhicule n'existe pas ou vous n'y avez pas accès.",
        "selectexistingornew": "",
        "validation": "Veuillez vous assurer que tous les champs sont correctement entrés.",
        "validationtitle": "Erreur de validation"
      },
      "fields": {
        "description": "Description du véhicule",
        "notes": "",
        "plate_no": "Plaque d'immatriculation",
        "plate_st": "Juridiction de la plaque",
        "trim_color": "Couleur de garniture",
        "v_bstyle": "Style corporel",
        "v_color": "Couleur",
        "v_cond": "Etat",
        "v_engine": "moteur",
        "v_make_desc": "Faire",
        "v_makecode": "Faire du code",
        "v_mldgcode": "Code de moulage",
        "v_model_desc": "Modèle",
        "v_model_yr": "année",
        "v_options": "Les options",
        "v_paint_codes": "Codes de peinture",
        "v_prod_dt": "Date de production",
        "v_stage": "Étape",
        "v_tone": "ton",
        "v_trimcode": "Code de coupe",
        "v_type": "Type",
        "v_vin": "V.I.N."
      },
      "forms": {
        "detail": "",
        "misc": "",
        "registration": ""
      },
      "labels": {
        "deleteconfirm": "",
        "fromvehicle": "",
        "novehinfo": "",
        "relatedjobs": "",
        "updatevehicle": ""
      },
      "successes": {
        "delete": "",
        "save": "Le véhicule a été enregistré avec succès."
      }
    },
    "vendors": {
      "actions": {
        "addtophonebook": "Add to Phonebook",
        "new": "Nouveau vendeur",
        "newpreferredmake": "New Preferred Make"
      },
      "errors": {
        "deleting": "Erreur rencontrée lors de la suppression du fournisseur.",
        "saving": "Erreur rencontrée lors de l'enregistrement du fournisseur."
      },
      "fields": {
        "active": "Active",
        "am": "",
        "city": "Ville",
        "cost_center": "Centre de coûts",
        "country": "Pays",
        "discount": "Discount",
        "display_name": "Afficher un nom",
        "dmsid": "DMS ID",
        "due_date": "Payment Due Date",
        "email": "Email du contact",
        "favorite": "Préféré?",
        "lkq": "",
        "make": "Make",
        "name": "Nom du vendeur",
        "oem": "",
        "phone": "Phone",
        "prompt_discount": "Remise rapide%",
        "state": "Etat / Province",
        "street1": "rue",
        "street2": "Adresse 2 ",
        "tags": "Tags",
        "taxid": "Identifiant de taxe",
        "terms": "Modalités de paiement",
        "zip": "Zip / code postal"
      },
      "labels": {
        "inputprefixes": {
          "days": "# Of Days",
          "discount": "%"
        },
        "noneselected": "Aucun fournisseur n'est sélectionné.",
        "preferredmakes": "Preferred Makes for Vendor",
        "search": "Tapez le nom d'un vendeur",
        "sections": {
          "address": "Address",
          "billing": "Billing Defaults",
          "contact": "Contact",
          "location": "Location",
          "tags": "Tags",
          "vendor": "Vendor Details"
        },
        "vendor": "Vendor"
      },
      "successes": {
        "deleted": "Le fournisseur a bien été supprimé.",
        "saved": "Le fournisseur a bien enregistré."
      },
      "validation": {
        "unique_vendor_name": ""
      }
    }
  }
}
